var js = Object.defineProperty;
var un = (e) => {
  throw TypeError(e);
};
var Is = (e, t, a) => t in e ? js(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var Wt = (e, t, a) => Is(e, typeof t != "symbol" ? t + "" : t, a), vn = (e, t, a) => t.has(e) || un("Cannot " + a);
var xe = (e, t, a) => (vn(e, t, "read from private field"), a ? a.call(e) : t.get(e)), Et = (e, t, a) => t.has(e) ? un("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, a), xa = (e, t, a, n) => (vn(e, t, "write to private field"), n ? n.call(e, a) : t.set(e, a), a);
const Ps = "5";
var On;
typeof window < "u" && ((On = window.__svelte ?? (window.__svelte = {})).v ?? (On.v = /* @__PURE__ */ new Set())).add(Ps);
const Wa = 1, Ua = 2, Mn = 4, Os = 8, Ms = 16, Ns = 1, Hs = 2, Ds = 4, Bs = 1, Rs = 2, ke = Symbol(), Fs = "http://www.w3.org/1999/xhtml", fn = !1, Me = 2, Nn = 4, ca = 8, _a = 16, Ve = 32, pt = 64, Yt = 128, Le = 256, Kt = 512, Se = 1024, We = 2048, wt = 4096, Fe = 8192, da = 16384, Hn = 32768, ua = 65536, Vs = 1 << 19, Dn = 1 << 20, Sa = 1 << 21, vt = Symbol("$state"), Ws = Symbol("");
var qa = Array.isArray, Us = Array.prototype.indexOf, $a = Array.from, Bn = Object.defineProperty, At = Object.getOwnPropertyDescriptor, Rn = Object.getOwnPropertyDescriptors, qs = Object.prototype, $s = Array.prototype, Ga = Object.getPrototypeOf, hn = Object.isExtensible;
function Gs(e) {
  return typeof e == "function";
}
const ze = () => {
};
function Za(e) {
  for (var t = 0; t < e.length; t++)
    e[t]();
}
let jt = [], Ta = [];
function Fn() {
  var e = jt;
  jt = [], Za(e);
}
function Zs() {
  var e = Ta;
  Ta = [], Za(e);
}
function va(e) {
  jt.length === 0 && queueMicrotask(Fn), jt.push(e);
}
function pn() {
  jt.length > 0 && Fn(), Ta.length > 0 && Zs();
}
function Vn(e) {
  return e === this.v;
}
function Ya(e, t) {
  return e != e ? t == t : e !== t || e !== null && typeof e == "object" || typeof e == "function";
}
function Wn(e) {
  return !Ya(e, this.v);
}
function Ys(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function Ks() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Xs(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Js() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Qs() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function er() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function tr() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
let Ht = !1, ar = !1;
function nr() {
  Ht = !0;
}
function Qe(e, t) {
  if (typeof e != "object" || e === null || vt in e)
    return e;
  const a = Ga(e);
  if (a !== qs && a !== $s)
    return e;
  var n = /* @__PURE__ */ new Map(), s = qa(e), r = X(0), i = B, l = (c) => {
    var o = B;
    je(i);
    var d;
    return d = c(), je(o), d;
  };
  return s && n.set("length", X(
    /** @type {any[]} */
    e.length
  )), new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(c, o, d) {
        (!("value" in d) || d.configurable === !1 || d.enumerable === !1 || d.writable === !1) && Qs();
        var f = n.get(o);
        return f === void 0 ? (f = l(() => X(d.value)), n.set(o, f)) : j(
          f,
          l(() => Qe(d.value))
        ), !0;
      },
      deleteProperty(c, o) {
        var d = n.get(o);
        if (d === void 0)
          o in c && n.set(
            o,
            l(() => X(ke))
          );
        else {
          if (s && typeof o == "string") {
            var f = (
              /** @type {Source<number>} */
              n.get("length")
            ), _ = Number(o);
            Number.isInteger(_) && _ < f.v && j(f, _);
          }
          j(d, ke), wn(r);
        }
        return !0;
      },
      get(c, o, d) {
        var h;
        if (o === vt)
          return e;
        var f = n.get(o), _ = o in c;
        if (f === void 0 && (!_ || (h = At(c, o)) != null && h.writable) && (f = l(() => X(Qe(_ ? c[o] : ke))), n.set(o, f)), f !== void 0) {
          var v = u(f);
          return v === ke ? void 0 : v;
        }
        return Reflect.get(c, o, d);
      },
      getOwnPropertyDescriptor(c, o) {
        var d = Reflect.getOwnPropertyDescriptor(c, o);
        if (d && "value" in d) {
          var f = n.get(o);
          f && (d.value = u(f));
        } else if (d === void 0) {
          var _ = n.get(o), v = _ == null ? void 0 : _.v;
          if (_ !== void 0 && v !== ke)
            return {
              enumerable: !0,
              configurable: !0,
              value: v,
              writable: !0
            };
        }
        return d;
      },
      has(c, o) {
        var v;
        if (o === vt)
          return !0;
        var d = n.get(o), f = d !== void 0 && d.v !== ke || Reflect.has(c, o);
        if (d !== void 0 || W !== null && (!f || (v = At(c, o)) != null && v.writable)) {
          d === void 0 && (d = l(() => X(f ? Qe(c[o]) : ke)), n.set(o, d));
          var _ = u(d);
          if (_ === ke)
            return !1;
        }
        return f;
      },
      set(c, o, d, f) {
        var S;
        var _ = n.get(o), v = o in c;
        if (s && o === "length")
          for (var h = d; h < /** @type {Source<number>} */
          _.v; h += 1) {
            var b = n.get(h + "");
            b !== void 0 ? j(b, ke) : h in c && (b = l(() => X(ke)), n.set(h + "", b));
          }
        _ === void 0 ? (!v || (S = At(c, o)) != null && S.writable) && (_ = l(() => X(void 0)), j(
          _,
          l(() => Qe(d))
        ), n.set(o, _)) : (v = _.v !== ke, j(
          _,
          l(() => Qe(d))
        ));
        var k = Reflect.getOwnPropertyDescriptor(c, o);
        if (k != null && k.set && k.set.call(f, d), !v) {
          if (s && typeof o == "string") {
            var g = (
              /** @type {Source<number>} */
              n.get("length")
            ), z = Number(o);
            Number.isInteger(z) && z >= g.v && j(g, z + 1);
          }
          wn(r);
        }
        return !0;
      },
      ownKeys(c) {
        u(r);
        var o = Reflect.ownKeys(c).filter((_) => {
          var v = n.get(_);
          return v === void 0 || v.v !== ke;
        });
        for (var [d, f] of n)
          f.v !== ke && !(d in c) && o.push(d);
        return o;
      },
      setPrototypeOf() {
        er();
      }
    }
  );
}
function wn(e, t = 1) {
  j(e, e.v + t);
}
const It = /* @__PURE__ */ new Map();
function at(e, t) {
  var a = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: Vn,
    rv: 0,
    wv: 0
  };
  return a;
}
function X(e, t) {
  const a = at(e);
  return Xn(a), a;
}
// @__NO_SIDE_EFFECTS__
function Un(e, t = !1) {
  var n;
  const a = at(e);
  return t || (a.equals = Wn), Ht && ee !== null && ee.l !== null && ((n = ee.l).s ?? (n.s = [])).push(a), a;
}
function j(e, t, a = !1) {
  B !== null && !Oe && ya() && (B.f & (Me | _a)) !== 0 && !(be != null && be.includes(e)) && tr();
  let n = a ? Qe(t) : t;
  return Ea(e, n);
}
function Ea(e, t) {
  if (!e.equals(t)) {
    var a = e.v;
    Dt ? It.set(e, t) : It.set(e, a), e.v = t, e.wv = Qn(), qn(e, We), ya() && W !== null && (W.f & Se) !== 0 && (W.f & (Ve | pt)) === 0 && (Ee === null ? dr([e]) : Ee.push(e));
  }
  return t;
}
function qn(e, t) {
  var a = e.reactions;
  if (a !== null)
    for (var n = ya(), s = a.length, r = 0; r < s; r++) {
      var i = a[r], l = i.f;
      (l & We) === 0 && (!n && i === W || (He(i, t), (l & (Se | Le)) !== 0 && ((l & Me) !== 0 ? qn(
        /** @type {Derived} */
        i,
        wt
      ) : wa(
        /** @type {Effect} */
        i
      ))));
    }
}
// @__NO_SIDE_EFFECTS__
function Ka(e) {
  var t = Me | We, a = B !== null && (B.f & Me) !== 0 ? (
    /** @type {Derived} */
    B
  ) : null;
  return W === null || a !== null && (a.f & Le) !== 0 ? t |= Le : W.f |= Dn, {
    ctx: ee,
    deps: null,
    effects: null,
    equals: Vn,
    f: t,
    fn: e,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      null
    ),
    wv: 0,
    parent: a ?? W
  };
}
function Aa(e) {
  const t = /* @__PURE__ */ Ka(e);
  return Xn(t), t;
}
// @__NO_SIDE_EFFECTS__
function sr(e) {
  const t = /* @__PURE__ */ Ka(e);
  return t.equals = Wn, t;
}
function $n(e) {
  var t = e.effects;
  if (t !== null) {
    e.effects = null;
    for (var a = 0; a < t.length; a += 1)
      Ye(
        /** @type {Effect} */
        t[a]
      );
  }
}
function rr(e) {
  for (var t = e.parent; t !== null; ) {
    if ((t.f & Me) === 0)
      return (
        /** @type {Effect} */
        t
      );
    t = t.parent;
  }
  return null;
}
function ir(e) {
  var t, a = W;
  Ne(rr(e));
  try {
    $n(e), t = ts(e);
  } finally {
    Ne(a);
  }
  return t;
}
function Gn(e) {
  var t = ir(e), a = ($e || (e.f & Le) !== 0) && e.deps !== null ? wt : Se;
  He(e, a), e.equals(t) || (e.v = t, e.wv = Qn());
}
let lr = !1;
var yn, Zn, Yn, Kn;
function or() {
  if (yn === void 0) {
    yn = window, Zn = /Firefox/.test(navigator.userAgent);
    var e = Element.prototype, t = Node.prototype, a = Text.prototype;
    Yn = At(t, "firstChild").get, Kn = At(t, "nextSibling").get, hn(e) && (e.__click = void 0, e.__className = void 0, e.__attributes = null, e.__style = void 0, e.__e = void 0), hn(a) && (a.__t = void 0);
  }
}
function fa(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function ht(e) {
  return Yn.call(e);
}
// @__NO_SIDE_EFFECTS__
function ha(e) {
  return Kn.call(e);
}
function p(e, t) {
  return /* @__PURE__ */ ht(e);
}
function Ge(e, t) {
  {
    var a = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ ht(
        /** @type {Node} */
        e
      )
    );
    return a instanceof Comment && a.data === "" ? /* @__PURE__ */ ha(a) : a;
  }
}
function m(e, t = 1, a = !1) {
  let n = e;
  for (; t--; )
    n = /** @type {TemplateNode} */
    /* @__PURE__ */ ha(n);
  return n;
}
function cr(e) {
  e.textContent = "";
}
let Zt = !1, Xt = !1, Jt = null, tt = !1, Dt = !1;
function bn(e) {
  Dt = e;
}
let Lt = [];
let B = null, Oe = !1;
function je(e) {
  B = e;
}
let W = null;
function Ne(e) {
  W = e;
}
let be = null;
function _r(e) {
  be = e;
}
function Xn(e) {
  B !== null && B.f & Sa && (be === null ? _r([e]) : be.push(e));
}
let ye = null, Ce = 0, Ee = null;
function dr(e) {
  Ee = e;
}
let Jn = 1, Qt = 0, $e = !1;
function Qn() {
  return ++Jn;
}
function Bt(e) {
  var f;
  var t = e.f;
  if ((t & We) !== 0)
    return !0;
  if ((t & wt) !== 0) {
    var a = e.deps, n = (t & Le) !== 0;
    if (a !== null) {
      var s, r, i = (t & Kt) !== 0, l = n && W !== null && !$e, c = a.length;
      if (i || l) {
        var o = (
          /** @type {Derived} */
          e
        ), d = o.parent;
        for (s = 0; s < c; s++)
          r = a[s], (i || !((f = r == null ? void 0 : r.reactions) != null && f.includes(o))) && (r.reactions ?? (r.reactions = [])).push(o);
        i && (o.f ^= Kt), l && d !== null && (d.f & Le) === 0 && (o.f ^= Le);
      }
      for (s = 0; s < c; s++)
        if (r = a[s], Bt(
          /** @type {Derived} */
          r
        ) && Gn(
          /** @type {Derived} */
          r
        ), r.wv > e.wv)
          return !0;
    }
    (!n || W !== null && !$e) && He(e, Se);
  }
  return !1;
}
function ur(e, t) {
  for (var a = t; a !== null; ) {
    if ((a.f & Yt) !== 0)
      try {
        a.fn(e);
        return;
      } catch {
        a.f ^= Yt;
      }
    a = a.parent;
  }
  throw Zt = !1, e;
}
function vr(e) {
  return (e.f & da) === 0 && (e.parent === null || (e.parent.f & Yt) === 0);
}
function pa(e, t, a, n) {
  if (Zt) {
    if (a === null && (Zt = !1), vr(t))
      throw e;
    return;
  }
  a !== null && (Zt = !0);
  {
    ur(e, t);
    return;
  }
}
function es(e, t, a = !0) {
  var n = e.reactions;
  if (n !== null)
    for (var s = 0; s < n.length; s++) {
      var r = n[s];
      be != null && be.includes(e) || ((r.f & Me) !== 0 ? es(
        /** @type {Derived} */
        r,
        t,
        !1
      ) : t === r && (a ? He(r, We) : (r.f & Se) !== 0 && He(r, wt), wa(
        /** @type {Effect} */
        r
      )));
    }
}
function ts(e) {
  var v;
  var t = ye, a = Ce, n = Ee, s = B, r = $e, i = be, l = ee, c = Oe, o = e.f;
  ye = /** @type {null | Value[]} */
  null, Ce = 0, Ee = null, $e = (o & Le) !== 0 && (Oe || !tt || B === null), B = (o & (Ve | pt)) === 0 ? e : null, be = null, gn(e.ctx), Oe = !1, Qt++, e.f |= Sa;
  try {
    var d = (
      /** @type {Function} */
      (0, e.fn)()
    ), f = e.deps;
    if (ye !== null) {
      var _;
      if (ea(e, Ce), f !== null && Ce > 0)
        for (f.length = Ce + ye.length, _ = 0; _ < ye.length; _++)
          f[Ce + _] = ye[_];
      else
        e.deps = f = ye;
      if (!$e)
        for (_ = Ce; _ < f.length; _++)
          ((v = f[_]).reactions ?? (v.reactions = [])).push(e);
    } else f !== null && Ce < f.length && (ea(e, Ce), f.length = Ce);
    if (ya() && Ee !== null && !Oe && f !== null && (e.f & (Me | wt | We)) === 0)
      for (_ = 0; _ < /** @type {Source[]} */
      Ee.length; _++)
        es(
          Ee[_],
          /** @type {Effect} */
          e
        );
    return s !== null && (Qt++, Ee !== null && (n === null ? n = Ee : n.push(.../** @type {Source[]} */
    Ee))), d;
  } finally {
    ye = t, Ce = a, Ee = n, B = s, $e = r, be = i, gn(l), Oe = c, e.f ^= Sa;
  }
}
function fr(e, t) {
  let a = t.reactions;
  if (a !== null) {
    var n = Us.call(a, e);
    if (n !== -1) {
      var s = a.length - 1;
      s === 0 ? a = t.reactions = null : (a[n] = a[s], a.pop());
    }
  }
  a === null && (t.f & Me) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (ye === null || !ye.includes(t)) && (He(t, wt), (t.f & (Le | Kt)) === 0 && (t.f ^= Kt), $n(
    /** @type {Derived} **/
    t
  ), ea(
    /** @type {Derived} **/
    t,
    0
  ));
}
function ea(e, t) {
  var a = e.deps;
  if (a !== null)
    for (var n = t; n < a.length; n++)
      fr(e, a[n]);
}
function Xa(e) {
  var t = e.f;
  if ((t & da) === 0) {
    He(e, Se);
    var a = W, n = ee, s = tt;
    W = e, tt = !0;
    try {
      (t & _a) !== 0 ? Sr(e) : rs(e), ss(e);
      var r = ts(e);
      e.teardown = typeof r == "function" ? r : null, e.wv = Jn;
      var i = e.deps, l;
      fn && ar && e.f & We;
    } catch (c) {
      pa(c, e, a, n || e.ctx);
    } finally {
      tt = s, W = a;
    }
  }
}
function hr() {
  try {
    Js();
  } catch (e) {
    if (Jt !== null)
      pa(e, Jt, null);
    else
      throw e;
  }
}
function as() {
  var e = tt;
  try {
    var t = 0;
    for (tt = !0; Lt.length > 0; ) {
      t++ > 1e3 && hr();
      var a = Lt, n = a.length;
      Lt = [];
      for (var s = 0; s < n; s++) {
        var r = wr(a[s]);
        pr(r);
      }
    }
  } finally {
    Xt = !1, tt = e, Jt = null, It.clear();
  }
}
function pr(e) {
  var t = e.length;
  if (t !== 0)
    for (var a = 0; a < t; a++) {
      var n = e[a];
      if ((n.f & (da | Fe)) === 0)
        try {
          Bt(n) && (Xa(n), n.deps === null && n.first === null && n.nodes_start === null && (n.teardown === null ? is(n) : n.fn = null));
        } catch (s) {
          pa(s, n, null, n.ctx);
        }
    }
}
function wa(e) {
  Xt || (Xt = !0, queueMicrotask(as));
  for (var t = Jt = e; t.parent !== null; ) {
    t = t.parent;
    var a = t.f;
    if ((a & (pt | Ve)) !== 0) {
      if ((a & Se) === 0) return;
      t.f ^= Se;
    }
  }
  Lt.push(t);
}
function wr(e) {
  for (var t = [], a = e; a !== null; ) {
    var n = a.f, s = (n & (Ve | pt)) !== 0, r = s && (n & Se) !== 0;
    if (!r && (n & Fe) === 0) {
      if ((n & Nn) !== 0)
        t.push(a);
      else if (s)
        a.f ^= Se;
      else {
        var i = B;
        try {
          B = a, Bt(a) && Xa(a);
        } catch (o) {
          pa(o, a, null, a.ctx);
        } finally {
          B = i;
        }
      }
      var l = a.first;
      if (l !== null) {
        a = l;
        continue;
      }
    }
    var c = a.parent;
    for (a = a.next; a === null && c !== null; )
      a = c.next, c = c.parent;
  }
  return t;
}
function yr(e) {
  var t;
  for (pn(); Lt.length > 0; )
    Xt = !0, as(), pn();
  return (
    /** @type {T} */
    t
  );
}
async function br() {
  await Promise.resolve(), yr();
}
function u(e) {
  var t = e.f, a = (t & Me) !== 0;
  if (B !== null && !Oe) {
    if (!(be != null && be.includes(e))) {
      var n = B.deps;
      e.rv < Qt && (e.rv = Qt, ye === null && n !== null && n[Ce] === e ? Ce++ : ye === null ? ye = [e] : (!$e || !ye.includes(e)) && ye.push(e));
    }
  } else if (a && /** @type {Derived} */
  e.deps === null && /** @type {Derived} */
  e.effects === null) {
    var s = (
      /** @type {Derived} */
      e
    ), r = s.parent;
    r !== null && (r.f & Le) === 0 && (s.f ^= Le);
  }
  return a && (s = /** @type {Derived} */
  e, Bt(s) && Gn(s)), Dt && It.has(e) ? It.get(e) : e.v;
}
function yt(e) {
  var t = Oe;
  try {
    return Oe = !0, e();
  } finally {
    Oe = t;
  }
}
const gr = -7169;
function He(e, t) {
  e.f = e.f & gr | t;
}
function mr(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (vt in e)
      La(e);
    else if (!Array.isArray(e))
      for (let t in e) {
        const a = e[t];
        typeof a == "object" && a && vt in a && La(a);
      }
  }
}
function La(e, t = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !t.has(e)) {
    t.add(e), e instanceof Date && e.getTime();
    for (let n in e)
      try {
        La(e[n], t);
      } catch {
      }
    const a = Ga(e);
    if (a !== Object.prototype && a !== Array.prototype && a !== Map.prototype && a !== Set.prototype && a !== Date.prototype) {
      const n = Rn(a);
      for (let s in n) {
        const r = n[s].get;
        if (r)
          try {
            r.call(e);
          } catch {
          }
      }
    }
  }
}
function xr(e) {
  W === null && B === null && Xs(), B !== null && (B.f & Le) !== 0 && W === null && Ks(), Dt && Ys();
}
function kr(e, t) {
  var a = t.last;
  a === null ? t.last = t.first = e : (a.next = e, e.prev = a, t.last = e);
}
function bt(e, t, a, n = !0) {
  var s = W, r = {
    ctx: ee,
    deps: null,
    nodes_start: null,
    nodes_end: null,
    f: e | We,
    first: null,
    fn: t,
    last: null,
    next: null,
    parent: s,
    prev: null,
    teardown: null,
    transitions: null,
    wv: 0
  };
  if (a)
    try {
      Xa(r), r.f |= Hn;
    } catch (c) {
      throw Ye(r), c;
    }
  else t !== null && wa(r);
  var i = a && r.deps === null && r.first === null && r.nodes_start === null && r.teardown === null && (r.f & (Dn | Yt)) === 0;
  if (!i && n && (s !== null && kr(r, s), B !== null && (B.f & Me) !== 0)) {
    var l = (
      /** @type {Derived} */
      B
    );
    (l.effects ?? (l.effects = [])).push(r);
  }
  return r;
}
function ns(e) {
  const t = bt(ca, null, !1);
  return He(t, Se), t.teardown = e, t;
}
function Cr(e) {
  xr();
  var t = W !== null && (W.f & Ve) !== 0 && ee !== null && !ee.m;
  if (t) {
    var a = (
      /** @type {ComponentContext} */
      ee
    );
    (a.e ?? (a.e = [])).push({
      fn: e,
      effect: W,
      reaction: B
    });
  } else {
    var n = Rt(e);
    return n;
  }
}
function zr(e) {
  const t = bt(pt, e, !0);
  return (a = {}) => new Promise((n) => {
    a.outro ? ta(t, () => {
      Ye(t), n(void 0);
    }) : (Ye(t), n(void 0));
  });
}
function Rt(e) {
  return bt(Nn, e, !1);
}
function Ja(e) {
  return bt(ca, e, !0);
}
function D(e, t = [], a = Ka) {
  const n = t.map(a);
  return Qa(() => e(...n.map(u)));
}
function Qa(e, t = 0) {
  return bt(ca | _a | t, e, !0);
}
function Pt(e, t = !0) {
  return bt(ca | Ve, e, !0, t);
}
function ss(e) {
  var t = e.teardown;
  if (t !== null) {
    const a = Dt, n = B;
    bn(!0), je(null);
    try {
      t.call(null);
    } finally {
      bn(a), je(n);
    }
  }
}
function rs(e, t = !1) {
  var a = e.first;
  for (e.first = e.last = null; a !== null; ) {
    var n = a.next;
    (a.f & pt) !== 0 ? a.parent = null : Ye(a, t), a = n;
  }
}
function Sr(e) {
  for (var t = e.first; t !== null; ) {
    var a = t.next;
    (t.f & Ve) === 0 && Ye(t), t = a;
  }
}
function Ye(e, t = !0) {
  var a = !1;
  if ((t || (e.f & Vs) !== 0) && e.nodes_start !== null) {
    for (var n = e.nodes_start, s = e.nodes_end; n !== null; ) {
      var r = n === s ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ ha(n)
      );
      n.remove(), n = r;
    }
    a = !0;
  }
  rs(e, t && !a), ea(e, 0), He(e, da);
  var i = e.transitions;
  if (i !== null)
    for (const c of i)
      c.stop();
  ss(e);
  var l = e.parent;
  l !== null && l.first !== null && is(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes_start = e.nodes_end = null;
}
function is(e) {
  var t = e.parent, a = e.prev, n = e.next;
  a !== null && (a.next = n), n !== null && (n.prev = a), t !== null && (t.first === e && (t.first = n), t.last === e && (t.last = a));
}
function ta(e, t) {
  var a = [];
  en(e, a, !0), ls(a, () => {
    Ye(e), t && t();
  });
}
function ls(e, t) {
  var a = e.length;
  if (a > 0) {
    var n = () => --a || t();
    for (var s of e)
      s.out(n);
  } else
    t();
}
function en(e, t, a) {
  if ((e.f & Fe) === 0) {
    if (e.f ^= Fe, e.transitions !== null)
      for (const i of e.transitions)
        (i.is_global || a) && t.push(i);
    for (var n = e.first; n !== null; ) {
      var s = n.next, r = (n.f & ua) !== 0 || (n.f & Ve) !== 0;
      en(n, t, r ? a : !1), n = s;
    }
  }
}
function aa(e) {
  os(e, !0);
}
function os(e, t) {
  if ((e.f & Fe) !== 0) {
    e.f ^= Fe, (e.f & Se) === 0 && (e.f ^= Se), Bt(e) && (He(e, We), wa(e));
    for (var a = e.first; a !== null; ) {
      var n = a.next, s = (a.f & ua) !== 0 || (a.f & Ve) !== 0;
      os(a, s ? t : !1), a = n;
    }
    if (e.transitions !== null)
      for (const r of e.transitions)
        (r.is_global || t) && r.in();
  }
}
function cs(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
let ee = null;
function gn(e) {
  ee = e;
}
function gt(e, t = !1, a) {
  var n = ee = {
    p: ee,
    c: null,
    d: !1,
    e: null,
    m: !1,
    s: e,
    x: null,
    l: null
  };
  Ht && !t && (ee.l = {
    s: null,
    u: null,
    r1: [],
    r2: at(!1)
  }), ns(() => {
    n.d = !0;
  });
}
function mt(e) {
  const t = ee;
  if (t !== null) {
    const i = t.e;
    if (i !== null) {
      var a = W, n = B;
      t.e = null;
      try {
        for (var s = 0; s < i.length; s++) {
          var r = i[s];
          Ne(r.effect), je(r.reaction), Rt(r.fn);
        }
      } finally {
        Ne(a), je(n);
      }
    }
    ee = t.p, t.m = !0;
  }
  return (
    /** @type {T} */
    {}
  );
}
function ya() {
  return !Ht || ee !== null && ee.l === null;
}
const Tr = ["touchstart", "touchmove"];
function Er(e) {
  return Tr.includes(e);
}
function Ar(e) {
  var t = B, a = W;
  je(null), Ne(null);
  try {
    return e();
  } finally {
    je(t), Ne(a);
  }
}
const _s = /* @__PURE__ */ new Set(), ja = /* @__PURE__ */ new Set();
function xt(e) {
  for (var t = 0; t < e.length; t++)
    _s.add(e[t]);
  for (var a of ja)
    a(e);
}
function Ut(e) {
  var z;
  var t = this, a = (
    /** @type {Node} */
    t.ownerDocument
  ), n = e.type, s = ((z = e.composedPath) == null ? void 0 : z.call(e)) || [], r = (
    /** @type {null | Element} */
    s[0] || e.target
  ), i = 0, l = e.__root;
  if (l) {
    var c = s.indexOf(l);
    if (c !== -1 && (t === document || t === /** @type {any} */
    window)) {
      e.__root = t;
      return;
    }
    var o = s.indexOf(t);
    if (o === -1)
      return;
    c <= o && (i = c);
  }
  if (r = /** @type {Element} */
  s[i] || e.target, r !== t) {
    Bn(e, "currentTarget", {
      configurable: !0,
      get() {
        return r || a;
      }
    });
    var d = B, f = W;
    je(null), Ne(null);
    try {
      for (var _, v = []; r !== null; ) {
        var h = r.assignedSlot || r.parentNode || /** @type {any} */
        r.host || null;
        try {
          var b = r["__" + n];
          if (b != null && (!/** @type {any} */
          r.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          e.target === r))
            if (qa(b)) {
              var [k, ...g] = b;
              k.apply(r, [e, ...g]);
            } else
              b.call(r, e);
        } catch (S) {
          _ ? v.push(S) : _ = S;
        }
        if (e.cancelBubble || h === t || h === null)
          break;
        r = h;
      }
      if (_) {
        for (let S of v)
          queueMicrotask(() => {
            throw S;
          });
        throw _;
      }
    } finally {
      e.__root = t, delete e.currentTarget, je(d), Ne(f);
    }
  }
}
function ds(e) {
  var t = document.createElement("template");
  return t.innerHTML = e, t.content;
}
function Ot(e, t) {
  var a = (
    /** @type {Effect} */
    W
  );
  a.nodes_start === null && (a.nodes_start = e, a.nodes_end = t);
}
// @__NO_SIDE_EFFECTS__
function U(e, t) {
  var a = (t & Bs) !== 0, n = (t & Rs) !== 0, s, r = !e.startsWith("<!>");
  return () => {
    s === void 0 && (s = ds(r ? e : "<!>" + e), a || (s = /** @type {Node} */
    /* @__PURE__ */ ht(s)));
    var i = (
      /** @type {TemplateNode} */
      n || Zn ? document.importNode(s, !0) : s.cloneNode(!0)
    );
    if (a) {
      var l = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ ht(i)
      ), c = (
        /** @type {TemplateNode} */
        i.lastChild
      );
      Ot(l, c);
    } else
      Ot(i, i);
    return i;
  };
}
// @__NO_SIDE_EFFECTS__
function ba(e, t, a = "svg") {
  var n = !e.startsWith("<!>"), s = `<${a}>${n ? e : "<!>" + e}</${a}>`, r;
  return () => {
    if (!r) {
      var i = (
        /** @type {DocumentFragment} */
        ds(s)
      ), l = (
        /** @type {Element} */
        /* @__PURE__ */ ht(i)
      );
      r = /** @type {Element} */
      /* @__PURE__ */ ht(l);
    }
    var c = (
      /** @type {TemplateNode} */
      r.cloneNode(!0)
    );
    return Ot(c, c), c;
  };
}
function mn(e = "") {
  {
    var t = fa(e + "");
    return Ot(t, t), t;
  }
}
function ga() {
  var e = document.createDocumentFragment(), t = document.createComment(""), a = fa();
  return e.append(t, a), Ot(t, a), e;
}
function A(e, t) {
  e !== null && e.before(
    /** @type {Node} */
    t
  );
}
let Ia = !0;
function L(e, t) {
  var a = t == null ? "" : typeof t == "object" ? t + "" : t;
  a !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = a, e.nodeValue = a + "");
}
function tn(e, t) {
  return Lr(e, t);
}
const _t = /* @__PURE__ */ new Map();
function Lr(e, { target: t, anchor: a, props: n = {}, events: s, context: r, intro: i = !0 }) {
  or();
  var l = /* @__PURE__ */ new Set(), c = (f) => {
    for (var _ = 0; _ < f.length; _++) {
      var v = f[_];
      if (!l.has(v)) {
        l.add(v);
        var h = Er(v);
        t.addEventListener(v, Ut, { passive: h });
        var b = _t.get(v);
        b === void 0 ? (document.addEventListener(v, Ut, { passive: h }), _t.set(v, 1)) : _t.set(v, b + 1);
      }
    }
  };
  c($a(_s)), ja.add(c);
  var o = void 0, d = zr(() => {
    var f = a ?? t.appendChild(fa());
    return Pt(() => {
      if (r) {
        gt({});
        var _ = (
          /** @type {ComponentContext} */
          ee
        );
        _.c = r;
      }
      s && (n.$$events = s), Ia = i, o = e(f, n) || {}, Ia = !0, r && mt();
    }), () => {
      var h;
      for (var _ of l) {
        t.removeEventListener(_, Ut);
        var v = (
          /** @type {number} */
          _t.get(_)
        );
        --v === 0 ? (document.removeEventListener(_, Ut), _t.delete(_)) : _t.set(_, v);
      }
      ja.delete(c), f !== a && ((h = f.parentNode) == null || h.removeChild(f));
    };
  });
  return Pa.set(o, d), o;
}
let Pa = /* @__PURE__ */ new WeakMap();
function an(e, t) {
  const a = Pa.get(e);
  return a ? (Pa.delete(e), a(t)) : Promise.resolve();
}
function J(e, t, [a, n] = [0, 0]) {
  var s = e, r = null, i = null, l = ke, c = a > 0 ? ua : 0, o = !1;
  const d = (_, v = !0) => {
    o = !0, f(v, _);
  }, f = (_, v) => {
    l !== (l = _) && (l ? (r ? aa(r) : v && (r = Pt(() => v(s))), i && ta(i, () => {
      i = null;
    })) : (i ? aa(i) : v && (i = Pt(() => v(s, [a + 1, n]))), r && ta(r, () => {
      r = null;
    })));
  };
  Qa(() => {
    o = !1, t(d), o || f(null, null);
  }, c);
}
function nn(e, t) {
  return t;
}
function jr(e, t, a, n) {
  for (var s = [], r = t.length, i = 0; i < r; i++)
    en(t[i].e, s, !0);
  var l = r > 0 && s.length === 0 && a !== null;
  if (l) {
    var c = (
      /** @type {Element} */
      /** @type {Element} */
      a.parentNode
    );
    cr(c), c.append(
      /** @type {Element} */
      a
    ), n.clear(), qe(e, t[0].prev, t[r - 1].next);
  }
  ls(s, () => {
    for (var o = 0; o < r; o++) {
      var d = t[o];
      l || (n.delete(d.k), qe(e, d.prev, d.next)), Ye(d.e, !l);
    }
  });
}
function na(e, t, a, n, s, r = null) {
  var i = e, l = { flags: t, items: /* @__PURE__ */ new Map(), first: null }, c = (t & Mn) !== 0;
  if (c) {
    var o = (
      /** @type {Element} */
      e
    );
    i = o.appendChild(fa());
  }
  var d = null, f = !1, _ = /* @__PURE__ */ sr(() => {
    var v = a();
    return qa(v) ? v : v == null ? [] : $a(v);
  });
  Qa(() => {
    var v = u(_), h = v.length;
    f && h === 0 || (f = h === 0, Ir(v, l, i, s, t, n, a), r !== null && (h === 0 ? d ? aa(d) : d = Pt(() => r(i)) : d !== null && ta(d, () => {
      d = null;
    })), u(_));
  });
}
function Ir(e, t, a, n, s, r, i) {
  var ie, F, O, Q;
  var l = (s & Os) !== 0, c = (s & (Wa | Ua)) !== 0, o = e.length, d = t.items, f = t.first, _ = f, v, h = null, b, k = [], g = [], z, S, T, y;
  if (l)
    for (y = 0; y < o; y += 1)
      z = e[y], S = r(z, y), T = d.get(S), T !== void 0 && ((ie = T.a) == null || ie.measure(), (b ?? (b = /* @__PURE__ */ new Set())).add(T));
  for (y = 0; y < o; y += 1) {
    if (z = e[y], S = r(z, y), T = d.get(S), T === void 0) {
      var M = _ ? (
        /** @type {TemplateNode} */
        _.e.nodes_start
      ) : a;
      h = Or(
        M,
        t,
        h,
        h === null ? t.first : h.next,
        z,
        S,
        y,
        n,
        s,
        i
      ), d.set(S, h), k = [], g = [], _ = h.next;
      continue;
    }
    if (c && Pr(T, z, y, s), (T.e.f & Fe) !== 0 && (aa(T.e), l && ((F = T.a) == null || F.unfix(), (b ?? (b = /* @__PURE__ */ new Set())).delete(T))), T !== _) {
      if (v !== void 0 && v.has(T)) {
        if (k.length < g.length) {
          var $ = g[0], q;
          h = $.prev;
          var te = k[0], G = k[k.length - 1];
          for (q = 0; q < k.length; q += 1)
            xn(k[q], $, a);
          for (q = 0; q < g.length; q += 1)
            v.delete(g[q]);
          qe(t, te.prev, G.next), qe(t, h, te), qe(t, G, $), _ = $, h = G, y -= 1, k = [], g = [];
        } else
          v.delete(T), xn(T, _, a), qe(t, T.prev, T.next), qe(t, T, h === null ? t.first : h.next), qe(t, h, T), h = T;
        continue;
      }
      for (k = [], g = []; _ !== null && _.k !== S; )
        (_.e.f & Fe) === 0 && (v ?? (v = /* @__PURE__ */ new Set())).add(_), g.push(_), _ = _.next;
      if (_ === null)
        continue;
      T = _;
    }
    k.push(T), h = T, _ = T.next;
  }
  if (_ !== null || v !== void 0) {
    for (var R = v === void 0 ? [] : $a(v); _ !== null; )
      (_.e.f & Fe) === 0 && R.push(_), _ = _.next;
    var Z = R.length;
    if (Z > 0) {
      var re = (s & Mn) !== 0 && o === 0 ? a : null;
      if (l) {
        for (y = 0; y < Z; y += 1)
          (O = R[y].a) == null || O.measure();
        for (y = 0; y < Z; y += 1)
          (Q = R[y].a) == null || Q.fix();
      }
      jr(t, R, re, d);
    }
  }
  l && va(() => {
    var x;
    if (b !== void 0)
      for (T of b)
        (x = T.a) == null || x.apply();
  }), W.first = t.first && t.first.e, W.last = h && h.e;
}
function Pr(e, t, a, n) {
  (n & Wa) !== 0 && Ea(e.v, t), (n & Ua) !== 0 ? Ea(
    /** @type {Value<number>} */
    e.i,
    a
  ) : e.i = a;
}
function Or(e, t, a, n, s, r, i, l, c, o) {
  var d = (c & Wa) !== 0, f = (c & Ms) === 0, _ = d ? f ? /* @__PURE__ */ Un(s) : at(s) : s, v = (c & Ua) === 0 ? i : at(i), h = {
    i: v,
    v: _,
    k: r,
    a: null,
    // @ts-expect-error
    e: null,
    prev: a,
    next: n
  };
  try {
    return h.e = Pt(() => l(e, _, v, o), lr), h.e.prev = a && a.e, h.e.next = n && n.e, a === null ? t.first = h : (a.next = h, a.e.next = h.e), n !== null && (n.prev = h, n.e.prev = h.e), h;
  } finally {
  }
}
function xn(e, t, a) {
  for (var n = e.next ? (
    /** @type {TemplateNode} */
    e.next.e.nodes_start
  ) : a, s = t ? (
    /** @type {TemplateNode} */
    t.e.nodes_start
  ) : a, r = (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ); r !== n; ) {
    var i = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ ha(r)
    );
    s.before(r), r = i;
  }
}
function qe(e, t, a) {
  t === null ? e.first = a : (t.next = a, t.e.next = a && a.e), a !== null && (a.prev = t, a.e.prev = t && t.e);
}
function nt(e, t) {
  va(() => {
    var a = e.getRootNode(), n = (
      /** @type {ShadowRoot} */
      a.host ? (
        /** @type {ShadowRoot} */
        a
      ) : (
        /** @type {Document} */
        a.head ?? /** @type {Document} */
        a.ownerDocument.head
      )
    );
    if (!n.querySelector("#" + t.hash)) {
      const s = document.createElement("style");
      s.id = t.hash, s.textContent = t.code, n.appendChild(s);
    }
  });
}
function Mr(e, t, a) {
  Rt(() => {
    var n = yt(() => t(e, a == null ? void 0 : a()) || {});
    if (n != null && n.update) {
      var s = !1, r = (
        /** @type {any} */
        {}
      );
      Ja(() => {
        var i = a();
        mr(i), s && Ya(r, i) && (r = i, n.update(i));
      }), s = !0;
    }
    if (n != null && n.destroy)
      return () => (
        /** @type {Function} */
        n.destroy()
      );
  });
}
const kn = [...` 	
\r\f \v\uFEFF`];
function Nr(e, t, a) {
  var n = e == null ? "" : "" + e;
  if (t && (n = n ? n + " " + t : t), a) {
    for (var s in a)
      if (a[s])
        n = n ? n + " " + s : s;
      else if (n.length)
        for (var r = s.length, i = 0; (i = n.indexOf(s, i)) >= 0; ) {
          var l = i + r;
          (i === 0 || kn.includes(n[i - 1])) && (l === n.length || kn.includes(n[l])) ? n = (i === 0 ? "" : n.substring(0, i)) + n.substring(l + 1) : i = l;
        }
  }
  return n === "" ? null : n;
}
function Cn(e, t = !1) {
  var a = t ? " !important;" : ";", n = "";
  for (var s in e) {
    var r = e[s];
    r != null && r !== "" && (n += " " + s + ": " + r + a);
  }
  return n;
}
function Hr(e, t) {
  if (t) {
    var a = "", n, s;
    return Array.isArray(t) ? (n = t[0], s = t[1]) : n = t, n && (a += Cn(n)), s && (a += Cn(s, !0)), a = a.trim(), a === "" ? null : a;
  }
  return String(e);
}
function Be(e, t, a, n, s, r) {
  var i = e.__className;
  if (i !== a) {
    var l = Nr(a, n, r);
    l == null ? e.removeAttribute("class") : e.className = l, e.__className = a;
  } else if (r && s !== r)
    for (var c in r) {
      var o = !!r[c];
      (s == null || o !== !!s[c]) && e.classList.toggle(c, o);
    }
  return r;
}
function ka(e, t = {}, a, n) {
  for (var s in a) {
    var r = a[s];
    t[s] !== r && (a[s] == null ? e.style.removeProperty(s) : e.style.setProperty(s, r, n));
  }
}
function Ae(e, t, a, n) {
  var s = e.__style;
  if (s !== t) {
    var r = Hr(t, n);
    r == null ? e.removeAttribute("style") : e.style.cssText = r, e.__style = t;
  } else n && (Array.isArray(n) ? (ka(e, a == null ? void 0 : a[0], n[0]), ka(e, a == null ? void 0 : a[1], n[1], "important")) : ka(e, a, n));
  return n;
}
const Dr = Symbol("is custom element"), Br = Symbol("is html");
function N(e, t, a, n) {
  var s = Rr(e);
  s[t] !== (s[t] = a) && (t === "loading" && (e[Ws] = a), a == null ? e.removeAttribute(t) : typeof a != "string" && Fr(e).includes(t) ? e[t] = a : e.setAttribute(t, a));
}
function Rr(e) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    // @ts-expect-error
    e.__attributes ?? (e.__attributes = {
      [Dr]: e.nodeName.includes("-"),
      [Br]: e.namespaceURI === Fs
    })
  );
}
var zn = /* @__PURE__ */ new Map();
function Fr(e) {
  var t = zn.get(e.nodeName);
  if (t) return t;
  zn.set(e.nodeName, t = []);
  for (var a, n = e, s = Element.prototype; s !== n; ) {
    a = Rn(n);
    for (var r in a)
      a[r].set && t.push(r);
    n = Ga(n);
  }
  return t;
}
const Vr = () => performance.now(), Pe = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => Vr(),
  tasks: /* @__PURE__ */ new Set()
};
function us() {
  const e = Pe.now();
  Pe.tasks.forEach((t) => {
    t.c(e) || (Pe.tasks.delete(t), t.f());
  }), Pe.tasks.size !== 0 && Pe.tick(us);
}
function sn(e) {
  let t;
  return Pe.tasks.size === 0 && Pe.tick(us), {
    promise: new Promise((a) => {
      Pe.tasks.add(t = { c: e, f: a });
    }),
    abort() {
      Pe.tasks.delete(t);
    }
  };
}
function qt(e, t) {
  Ar(() => {
    e.dispatchEvent(new CustomEvent(t));
  });
}
function Wr(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const t = e.split("-");
  return t.length === 1 ? t[0] : t[0] + t.slice(1).map(
    /** @param {any} word */
    (a) => a[0].toUpperCase() + a.slice(1)
  ).join("");
}
function Sn(e) {
  const t = {}, a = e.split(";");
  for (const n of a) {
    const [s, r] = n.split(":");
    if (!s || r === void 0) break;
    const i = Wr(s.trim());
    t[i] = r.trim();
  }
  return t;
}
const Ur = (e) => e;
function sa(e, t, a, n) {
  var s = (e & Ns) !== 0, r = (e & Hs) !== 0, i = s && r, l = (e & Ds) !== 0, c = i ? "both" : s ? "in" : "out", o, d = t.inert, f = t.style.overflow, _, v;
  function h() {
    var S = B, T = W;
    je(null), Ne(null);
    try {
      return o ?? (o = a()(t, (n == null ? void 0 : n()) ?? /** @type {P} */
      {}, {
        direction: c
      }));
    } finally {
      je(S), Ne(T);
    }
  }
  var b = {
    is_global: l,
    in() {
      var S;
      if (t.inert = d, !s) {
        v == null || v.abort(), (S = v == null ? void 0 : v.reset) == null || S.call(v);
        return;
      }
      r || _ == null || _.abort(), qt(t, "introstart"), _ = Oa(t, h(), v, 1, () => {
        qt(t, "introend"), _ == null || _.abort(), _ = o = void 0, t.style.overflow = f;
      });
    },
    out(S) {
      if (!r) {
        S == null || S(), o = void 0;
        return;
      }
      t.inert = !0, qt(t, "outrostart"), v = Oa(t, h(), _, 0, () => {
        qt(t, "outroend"), S == null || S();
      });
    },
    stop: () => {
      _ == null || _.abort(), v == null || v.abort();
    }
  }, k = (
    /** @type {Effect} */
    W
  );
  if ((k.transitions ?? (k.transitions = [])).push(b), s && Ia) {
    var g = l;
    if (!g) {
      for (var z = (
        /** @type {Effect | null} */
        k.parent
      ); z && (z.f & ua) !== 0; )
        for (; (z = z.parent) && (z.f & _a) === 0; )
          ;
      g = !z || (z.f & Hn) !== 0;
    }
    g && Rt(() => {
      yt(() => b.in());
    });
  }
}
function Oa(e, t, a, n, s) {
  var r = n === 1;
  if (Gs(t)) {
    var i, l = !1;
    return va(() => {
      if (!l) {
        var k = t({ direction: r ? "in" : "out" });
        i = Oa(e, k, a, n, s);
      }
    }), {
      abort: () => {
        l = !0, i == null || i.abort();
      },
      deactivate: () => i.deactivate(),
      reset: () => i.reset(),
      t: () => i.t()
    };
  }
  if (a == null || a.deactivate(), !(t != null && t.duration))
    return s(), {
      abort: ze,
      deactivate: ze,
      reset: ze,
      t: () => n
    };
  const { delay: c = 0, css: o, tick: d, easing: f = Ur } = t;
  var _ = [];
  if (r && a === void 0 && (d && d(0, 1), o)) {
    var v = Sn(o(0, 1));
    _.push(v, v);
  }
  var h = () => 1 - n, b = e.animate(_, { duration: c });
  return b.onfinish = () => {
    var k = (a == null ? void 0 : a.t()) ?? 1 - n;
    a == null || a.abort();
    var g = n - k, z = (
      /** @type {number} */
      t.duration * Math.abs(g)
    ), S = [];
    if (z > 0) {
      var T = !1;
      if (o)
        for (var y = Math.ceil(z / 16.666666666666668), M = 0; M <= y; M += 1) {
          var $ = k + g * f(M / y), q = Sn(o($, 1 - $));
          S.push(q), T || (T = q.overflow === "hidden");
        }
      T && (e.style.overflow = "hidden"), h = () => {
        var te = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          b.currentTime
        );
        return k + g * f(te / z);
      }, d && sn(() => {
        if (b.playState !== "running") return !1;
        var te = h();
        return d(te, 1 - te), !0;
      });
    }
    b = e.animate(S, { duration: z, fill: "forwards" }), b.onfinish = () => {
      h = () => n, d == null || d(n, 1 - n), s();
    };
  }, {
    abort: () => {
      b && (b.cancel(), b.effect = null, b.onfinish = ze);
    },
    deactivate: () => {
      s = ze;
    },
    reset: () => {
      n === 0 && (d == null || d(1, 0));
    },
    t: () => h()
  };
}
function Tn(e, t) {
  return e === t || (e == null ? void 0 : e[vt]) === t;
}
function rn(e = {}, t, a, n) {
  return Rt(() => {
    var s, r;
    return Ja(() => {
      s = r, r = [], yt(() => {
        e !== a(...r) && (t(e, ...r), s && Tn(a(...s), e) && t(null, ...s));
      });
    }), () => {
      va(() => {
        r && Tn(a(...r), e) && t(null, ...r);
      });
    };
  }), e;
}
function Ft(e) {
  ee === null && cs(), Ht && ee.l !== null ? qr(ee).m.push(e) : Cr(() => {
    const t = yt(e);
    if (typeof t == "function") return (
      /** @type {() => void} */
      t
    );
  });
}
function ln(e) {
  ee === null && cs(), Ft(() => () => yt(e));
}
function qr(e) {
  var t = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return t.u ?? (t.u = { a: [], b: [], m: [] });
}
function on(e, t, a) {
  if (e == null)
    return t(void 0), a && a(void 0), ze;
  const n = yt(
    () => e.subscribe(
      t,
      // @ts-expect-error
      a
    )
  );
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
const dt = [];
function $r(e, t) {
  return {
    subscribe: cn(e, t).subscribe
  };
}
function cn(e, t = ze) {
  let a = null;
  const n = /* @__PURE__ */ new Set();
  function s(l) {
    if (Ya(e, l) && (e = l, a)) {
      const c = !dt.length;
      for (const o of n)
        o[1](), dt.push(o, e);
      if (c) {
        for (let o = 0; o < dt.length; o += 2)
          dt[o][0](dt[o + 1]);
        dt.length = 0;
      }
    }
  }
  function r(l) {
    s(l(
      /** @type {T} */
      e
    ));
  }
  function i(l, c = ze) {
    const o = [l, c];
    return n.add(o), n.size === 1 && (a = t(s, r) || ze), l(
      /** @type {T} */
      e
    ), () => {
      n.delete(o), n.size === 0 && a && (a(), a = null);
    };
  }
  return { set: s, update: r, subscribe: i };
}
function Gr(e, t, a) {
  const n = !Array.isArray(e), s = n ? [e] : e;
  if (!s.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const r = t.length < 2;
  return $r(a, (i, l) => {
    let c = !1;
    const o = [];
    let d = 0, f = ze;
    const _ = () => {
      if (d)
        return;
      f();
      const h = t(n ? o[0] : o, i, l);
      r ? i(h) : f = typeof h == "function" ? h : ze;
    }, v = s.map(
      (h, b) => on(
        h,
        (k) => {
          o[b] = k, d &= ~(1 << b), c && _();
        },
        () => {
          d |= 1 << b;
        }
      )
    );
    return c = !0, _(), function() {
      Za(v), f(), c = !1;
    };
  });
}
function Ma(e) {
  let t;
  return on(e, (a) => t = a)(), t;
}
let Na = Symbol();
function Ha(e, t, a) {
  const n = a[t] ?? (a[t] = {
    store: null,
    source: /* @__PURE__ */ Un(void 0),
    unsubscribe: ze
  });
  if (n.store !== e && !(Na in a))
    if (n.unsubscribe(), n.store = e ?? null, e == null)
      n.source.v = void 0, n.unsubscribe = ze;
    else {
      var s = !0;
      n.unsubscribe = on(e, (r) => {
        s ? n.source.v = r : j(n.source, r);
      }), s = !1;
    }
  return e && Na in a ? Ma(e) : u(n.source);
}
function vs() {
  const e = {};
  function t() {
    ns(() => {
      for (var a in e)
        e[a].unsubscribe();
      Bn(e, Na, {
        enumerable: !1,
        value: !0
      });
    });
  }
  return [e, t];
}
function Ze(e, t, a, n) {
  var s;
  s = /** @type {V} */
  e[t];
  var r = (
    /** @type {V} */
    n
  ), i = !0, l = () => (i && (i = !1, r = /** @type {V} */
  n), r);
  s === void 0 && n !== void 0 && (s = l());
  var c;
  return c = () => {
    var o = (
      /** @type {V} */
      e[t]
    );
    return o === void 0 ? l() : (i = !0, o);
  }, c;
}
const Zr = (e) => e;
function Yr(e) {
  const t = e - 1;
  return t * t * t + 1;
}
function fs(e, { delay: t = 0, duration: a = 400, easing: n = Zr } = {}) {
  const s = +getComputedStyle(e).opacity;
  return {
    delay: t,
    duration: a,
    easing: n,
    css: (r) => `opacity: ${r * s}`
  };
}
function hs(e, { delay: t = 0, duration: a = 400, easing: n = Yr, axis: s = "y" } = {}) {
  const r = getComputedStyle(e), i = +r.opacity, l = s === "y" ? "height" : "width", c = parseFloat(r[l]), o = s === "y" ? ["top", "bottom"] : ["left", "right"], d = o.map(
    (g) => (
      /** @type {'Left' | 'Right' | 'Top' | 'Bottom'} */
      `${g[0].toUpperCase()}${g.slice(1)}`
    )
  ), f = parseFloat(r[`padding${d[0]}`]), _ = parseFloat(r[`padding${d[1]}`]), v = parseFloat(r[`margin${d[0]}`]), h = parseFloat(r[`margin${d[1]}`]), b = parseFloat(
    r[`border${d[0]}Width`]
  ), k = parseFloat(
    r[`border${d[1]}Width`]
  );
  return {
    delay: t,
    duration: a,
    easing: n,
    css: (g) => `overflow: hidden;opacity: ${Math.min(g * 20, 1) * i};${l}: ${g * c}px;padding-${o[0]}: ${g * f}px;padding-${o[1]}: ${g * _}px;margin-${o[0]}: ${g * v}px;margin-${o[1]}: ${g * h}px;border-${o[0]}-width: ${g * b}px;border-${o[1]}-width: ${g * k}px;min-${l}: 0`
  };
}
var Kr = /* @__PURE__ */ U('<span id="steady_cta_arrow" aria-hidden="true" class="svelte-1p8xlpl"><svg height="12" viewBox="0 0 27 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.3C0.613401 5.3 0.3 5.6134 0.3 6C0.3 6.3866 0.613401 6.7 1 6.7V5.3ZM26.495 6.49497C26.7683 6.22161 26.7683 5.77839 26.495 5.50503L22.0402 1.05025C21.7668 0.776886 21.3236 0.776886 21.0503 1.05025C20.7769 1.32362 20.7769 1.76684 21.0503 2.0402L25.01 6L21.0503 9.9598C20.7769 10.2332 20.7769 10.6764 21.0503 10.9497C21.3236 11.2231 21.7668 11.2231 22.0402 10.9497L26.495 6.49497ZM1 6.7H26V5.3H1V6.7Z"></path></svg></span>');
const Xr = {
  hash: "svelte-1p8xlpl",
  code: "#steady_cta_arrow.svelte-1p8xlpl {margin-left:15px;transform:translate(0, 1.5px);transition:transform 0.3s ease-out;}#steady_cta_arrow.svelte-1p8xlpl:where(:where(.svelte-1p8xlpl):hover, :where(.svelte-1p8xlpl):focus) {transform:translate(10px, 1.5px);}*:hover > #steady_cta_arrow.svelte-1p8xlpl, *:focus > #steady_cta_arrow.svelte-1p8xlpl {transform:translate(10px, 1.5px);}"
};
function Da(e, t) {
  nt(e, Xr);
  let a = Ze(t, "color", 3, "#271f36");
  var n = Kr(), s = p(n), r = p(s);
  D(() => N(r, "fill", a())), A(e, n);
}
var Jr = /* @__PURE__ */ U('<button id="steady_close_button" data-testid="steady_close_button" class="svelte-8examu"><svg aria-hidden="true" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="12.0919" y1="12.6601" x2="24.6711" y2="25.2393" stroke="#979797" stroke-width="1.5"></line><line x1="24.672" y1="12.5914" x2="12.0927" y2="25.1706" stroke="#979797" stroke-width="1.5"></line></svg></button>');
const Qr = {
  hash: "svelte-8examu",
  code: `#steady_close_button.svelte-8examu {background:none;border:0;border-radius:0;-webkit-appearance:none;padding:0;text-align:inherit;color:inherit;}#steady_close_button.svelte-8examu:active {color:inherit;}#steady_close_button.svelte-8examu {position:absolute;top:2px;right:4px;width:30px;height:30px;padding:0;background-color:transparent;}
@media (min-width: 440px) {#steady_close_button.svelte-8examu {top:8px;right:12px;width:37px;height:37px;}
}#steady_close_button.svelte-8examu:hover {border-color:unset;cursor:pointer;opacity:80%;}`
};
function _n(e, t) {
  gt(t, !0), nt(e, Qr);
  var a = Jr();
  a.__click = function(...n) {
    var s;
    (s = t.close) == null || s.apply(this, n);
  }, D(() => N(a, "aria-label", t.widgetSettings.localization.close)), A(e, a), mt();
}
xt(["click"]);
const ps = (e) => [
  parseInt(e.substring(1, 3), 16),
  parseInt(e.substring(3, 5), 16),
  parseInt(e.substring(5, 7), 16)
], ei = (e, t, a, n) => {
  e /= 255, t /= 255, a /= 255;
  const s = Math.min(e, t, a), r = Math.max(e, t, a), i = r - s;
  let l = 0, c = 0, o = 0;
  return i === 0 ? l = 0 : r === e ? l = (t - a) / i % 6 : r === t ? l = (a - e) / i + 2 : l = (e - t) / i + 4, l = Math.round(l * 60), l < 0 && (l += 360), o = (r + s) / 2, c = i === 0 ? 0 : i / (1 - Math.abs(2 * o - 1)), c = +(c * 100).toFixed(1), o = +(o * 100).toFixed(1), "hsl(" + l + "," + c + "%," + o * n + "%)";
}, ti = (e) => {
  const [t, a, n] = ps(e);
  return (t * 299 + a * 587 + n * 114) / 1e3;
}, Ba = (e) => ti(e) > 155, ws = (e) => {
  const [t, a, n] = ps(e);
  return ei(t, a, n, 0.6);
}, ma = (e) => Ba(e) ? ws(e) : e;
function ys(e) {
  return e;
}
function Mt(e) {
  return e < 0.5 ? 4 * e * e * e : 0.5 * Math.pow(2 * e - 2, 3) + 1;
}
function Ra(e) {
  return -0.5 * (Math.cos(Math.PI * e) - 1);
}
function En(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function ra(e, t) {
  if (e === t || e !== e) return () => e;
  const a = typeof e;
  if (a !== typeof t || Array.isArray(e) !== Array.isArray(t))
    throw new Error("Cannot interpolate values of different type");
  if (Array.isArray(e)) {
    const n = (
      /** @type {Array<any>} */
      t.map((s, r) => ra(
        /** @type {Array<any>} */
        e[r],
        s
      ))
    );
    return (s) => n.map((r) => r(s));
  }
  if (a === "object") {
    if (!e || !t)
      throw new Error("Object cannot be null");
    if (En(e) && En(t)) {
      const r = e.getTime(), l = t.getTime() - r;
      return (c) => new Date(r + c * l);
    }
    const n = Object.keys(t), s = {};
    return n.forEach((r) => {
      s[r] = ra(e[r], t[r]);
    }), (r) => {
      const i = {};
      return n.forEach((l) => {
        i[l] = s[l](r);
      }), i;
    };
  }
  if (a === "number") {
    const n = (
      /** @type {number} */
      t - /** @type {number} */
      e
    );
    return (s) => e + s * n;
  }
  return () => t;
}
function ia(e, t = {}) {
  const a = cn(e);
  let n, s = e;
  function r(i, l) {
    if (s = i, e == null)
      return a.set(e = i), Promise.resolve();
    let c = n, o = !1, {
      delay: d = 0,
      duration: f = 400,
      easing: _ = ys,
      interpolate: v = ra
    } = { ...t, ...l };
    if (f === 0)
      return c && (c.abort(), c = null), a.set(e = s), Promise.resolve();
    const h = Pe.now() + d;
    let b;
    return n = sn((k) => {
      if (k < h) return !0;
      o || (b = v(
        /** @type {any} */
        e,
        i
      ), typeof f == "function" && (f = f(
        /** @type {any} */
        e,
        i
      )), o = !0), c && (c.abort(), c = null);
      const g = k - h;
      return g > /** @type {number} */
      f ? (a.set(e = i), !1) : (a.set(e = b(_(g / f))), !0);
    }), n.promise;
  }
  return {
    set: r,
    update: (i, l) => r(i(
      /** @type {any} */
      s,
      /** @type {any} */
      e
    ), l),
    subscribe: a.subscribe
  };
}
var Re, ft, Nt, et;
const dn = class dn {
  /**
   * @param {T} value
   * @param {TweenedOptions<T>} options
   */
  constructor(t, a = {}) {
    Et(this, Re, at(
      /** @type {T} */
      void 0
    ));
    Et(this, ft, at(
      /** @type {T} */
      void 0
    ));
    /** @type {TweenedOptions<T>} */
    Et(this, Nt);
    /** @type {import('../internal/client/types').Task | null} */
    Et(this, et, null);
    xe(this, Re).v = xe(this, ft).v = t, xa(this, Nt, a);
  }
  /**
   * Create a tween whose value is bound to the return value of `fn`. This must be called
   * inside an effect root (for example, during component initialisation).
   *
   * ```svelte
   * <script>
   * 	import { Tween } from 'svelte/motion';
   *
   * 	let { number } = $props();
   *
   * 	const tween = Tween.of(() => number);
   * <\/script>
   * ```
   * @template U
   * @param {() => U} fn
   * @param {TweenedOptions<U>} [options]
   */
  static of(t, a) {
    const n = new dn(t(), a);
    return Ja(() => {
      n.set(t());
    }), n;
  }
  /**
   * Sets `tween.target` to `value` and returns a `Promise` that resolves if and when `tween.current` catches up to it.
   *
   * If `options` are provided, they will override the tween's defaults.
   * @param {T} value
   * @param {TweenedOptions<T>} [options]
   * @returns
   */
  set(t, a) {
    var f;
    j(xe(this, ft), t);
    let {
      delay: n = 0,
      duration: s = 400,
      easing: r = ys,
      interpolate: i = ra
    } = { ...xe(this, Nt), ...a };
    if (s === 0)
      return (f = xe(this, et)) == null || f.abort(), j(xe(this, Re), t), Promise.resolve();
    const l = Pe.now() + n;
    let c, o = !1, d = xe(this, et);
    return xa(this, et, sn((_) => {
      if (_ < l)
        return !0;
      if (!o) {
        o = !0;
        const h = xe(this, Re).v;
        c = i(h, t), typeof s == "function" && (s = s(h, t)), d == null || d.abort();
      }
      const v = _ - l;
      return v > /** @type {number} */
      s ? (j(xe(this, Re), t), !1) : (j(xe(this, Re), c(r(v / /** @type {number} */
      s))), !0);
    })), xe(this, et).promise;
  }
  get current() {
    return u(xe(this, Re));
  }
  get target() {
    return u(xe(this, ft));
  }
  set target(t) {
    this.set(t);
  }
};
Re = new WeakMap(), ft = new WeakMap(), Nt = new WeakMap(), et = new WeakMap();
let Fa = dn;
var $t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ai(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ca, An;
function ni() {
  if (An) return Ca;
  An = 1;
  var e = "Expected a function", t = NaN, a = "[object Symbol]", n = /^\s+|\s+$/g, s = /^[-+]0x[0-9a-f]+$/i, r = /^0b[01]+$/i, i = /^0o[0-7]+$/i, l = parseInt, c = typeof $t == "object" && $t && $t.Object === Object && $t, o = typeof self == "object" && self && self.Object === Object && self, d = c || o || Function("return this")(), f = Object.prototype, _ = f.toString, v = Math.max, h = Math.min, b = function() {
    return d.Date.now();
  };
  function k(y, M, $) {
    var q, te, G, R, Z, re, ie = 0, F = !1, O = !1, Q = !0;
    if (typeof y != "function")
      throw new TypeError(e);
    M = T(M) || 0, g($) && (F = !!$.leading, O = "maxWait" in $, G = O ? v(T($.maxWait) || 0, M) : G, Q = "trailing" in $ ? !!$.trailing : Q);
    function x(Y) {
      var le = q, me = te;
      return q = te = void 0, ie = Y, R = y.apply(me, le), R;
    }
    function w(Y) {
      return ie = Y, Z = setTimeout(ne, M), F ? x(Y) : R;
    }
    function I(Y) {
      var le = Y - re, me = Y - ie, fe = M - le;
      return O ? h(fe, G - me) : fe;
    }
    function P(Y) {
      var le = Y - re, me = Y - ie;
      return re === void 0 || le >= M || le < 0 || O && me >= G;
    }
    function ne() {
      var Y = b();
      if (P(Y))
        return de(Y);
      Z = setTimeout(ne, I(Y));
    }
    function de(Y) {
      return Z = void 0, Q && q ? x(Y) : (q = te = void 0, R);
    }
    function ue() {
      Z !== void 0 && clearTimeout(Z), ie = 0, q = re = te = Z = void 0;
    }
    function ge() {
      return Z === void 0 ? R : de(b());
    }
    function ve() {
      var Y = b(), le = P(Y);
      if (q = arguments, te = this, re = Y, le) {
        if (Z === void 0)
          return w(re);
        if (O)
          return Z = setTimeout(ne, M), x(re);
      }
      return Z === void 0 && (Z = setTimeout(ne, M)), R;
    }
    return ve.cancel = ue, ve.flush = ge, ve;
  }
  function g(y) {
    var M = typeof y;
    return !!y && (M == "object" || M == "function");
  }
  function z(y) {
    return !!y && typeof y == "object";
  }
  function S(y) {
    return typeof y == "symbol" || z(y) && _.call(y) == a;
  }
  function T(y) {
    if (typeof y == "number")
      return y;
    if (S(y))
      return t;
    if (g(y)) {
      var M = typeof y.valueOf == "function" ? y.valueOf() : y;
      y = g(M) ? M + "" : M;
    }
    if (typeof y != "string")
      return y === 0 ? y : +y;
    y = y.replace(n, "");
    var $ = r.test(y);
    return $ || i.test(y) ? l(y.slice(2), $ ? 2 : 8) : s.test(y) ? t : +y;
  }
  return Ca = k, Ca;
}
var si = ni();
const bs = /* @__PURE__ */ ai(si);
var ri = /* @__PURE__ */ ba('<svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.79269 7.71601C3.61151 7.71601 3.43033 7.64633 3.29095 7.50696L0.196896 4.32231C-0.0679103 4.04356 -0.0679103 3.60454 0.210834 3.33973C0.489578 3.06796 0.928599 3.07493 1.19341 3.35367L3.79966 6.03658L9.82053 0.196896C10.0993 -0.0679103 10.5383 -0.0679103 10.8031 0.210834C11.0679 0.489578 11.0679 0.928599 10.7892 1.19341L4.27353 7.52089C4.14112 7.6533 3.95994 7.71601 3.78572 7.71601H3.79269Z"></path></svg>');
function la(e, t) {
  let a = Ze(t, "color", 3, "#271f36");
  var n = ri(), s = p(n);
  D(() => N(s, "fill", a())), A(e, n);
}
var ii = /* @__PURE__ */ ba('<svg class="steady_logo svelte-172b6ih" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 20" fill="none"><path d="M15.5208 4.72013H17.5727V7.09906H15.5208V11.2473C15.5208 12.1171 15.9372 12.3996 16.7252 12.3996C17.0597 12.3996 17.4314 12.3624 17.5727 12.3178V14.5332C17.3273 14.6373 16.8293 14.7785 16.0189 14.7785C14.034 14.7785 12.7851 13.6263 12.7851 11.7157V7.09906H10.9414V4.72013H11.4618C12.5398 4.72013 13.0378 4.03619 13.0378 3.14409V1.75391H15.5208V4.72013Z"></path><path d="M28.9941 11.798C28.4737 13.5153 26.8605 14.9427 24.3552 14.9427C21.5599 14.9427 19.0918 12.9875 19.0918 9.64212C19.0918 6.47517 21.493 4.42334 24.1024 4.42334C27.2471 4.42334 29.1353 6.37852 29.1353 9.56778C29.1353 9.95435 29.0907 10.3558 29.0907 10.393H21.7978C21.8573 11.7014 23.0022 12.653 24.3626 12.653C25.6487 12.653 26.3475 12.0285 26.6821 11.1438L28.9941 11.798ZM26.4219 8.5493C26.3773 7.56055 25.7156 6.59411 24.147 6.59411C22.7197 6.59411 21.9316 7.64233 21.8722 8.5493H26.4219Z"></path><path d="M33.6027 8.95063L36.108 8.58636C36.6879 8.50458 36.8737 8.22208 36.8737 7.88011C36.8737 7.17387 36.3162 6.58657 35.1564 6.58657C33.9521 6.58657 33.2905 7.32999 33.2087 8.19978L30.7628 7.69426C30.9264 6.14052 32.3984 4.43066 35.1341 4.43066C38.368 4.43066 39.5649 6.20743 39.5649 8.19978V13.0766C39.5649 13.6044 39.6244 14.3032 39.6913 14.6526H37.1637C37.1042 14.3924 37.0596 13.8497 37.0596 13.4632C36.5392 14.2512 35.5653 14.9351 34.0562 14.9351C31.878 14.9351 30.5547 13.5003 30.5547 11.954C30.5621 10.1773 31.9077 9.18852 33.6027 8.95063ZM36.8737 10.6456V10.1996L34.5766 10.5415C33.8703 10.6456 33.3128 11.0248 33.3128 11.7905C33.3128 12.3778 33.7439 12.9428 34.636 12.9428C35.7958 12.9428 36.8737 12.4001 36.8737 10.6456Z"></path><path d="M9.17375 7.4862C9.18118 7.4862 9.18118 7.4862 9.17375 7.4862C8.91356 7.27804 8.62362 7.08475 8.29652 6.9212C8.26678 6.90633 8.24448 6.89146 8.21474 6.88403C8.11067 6.83199 7.99915 6.78739 7.89508 6.73535C7.47876 6.56436 7.02528 6.42311 6.51976 6.3339L5.25595 6.09601L4.45306 5.94733C3.36767 5.7466 2.84728 5.1147 2.84728 4.31925C2.84728 4.08135 2.90676 3.85089 3.01083 3.62787C3.38254 3.048 4.06648 2.51275 5.25595 2.49044C6.43798 2.52018 7.12936 3.048 7.50106 3.62787C7.56054 3.75425 7.60514 3.88063 7.63488 4.01444L10.3112 3.21156C10.2294 2.97366 10.1253 2.7432 10.0064 2.52018C9.47112 1.5017 8.46751 0.542693 6.75022 0.163551C6.3116 0.0594732 5.85068 0 5.3749 0C5.33773 0 5.30055 0 5.26338 0C5.22621 0 5.18904 0 5.15187 0C4.67609 0 4.21517 0.0594732 3.77655 0.163551C2.05926 0.535259 1.05565 1.5017 0.520391 2.52018C0.185854 3.11491 0 3.79142 0 4.51253C0 5.73917 0.490654 6.75022 1.33815 7.47876C1.59834 7.68692 1.88828 7.88021 2.21538 8.04376C2.24512 8.05863 2.26742 8.07349 2.29715 8.08093C2.40123 8.13297 2.51275 8.17757 2.61682 8.22961C3.03314 8.4006 3.48662 8.54185 3.99214 8.63106L5.25595 8.86895L6.05884 9.01763C7.14423 9.21836 7.66462 9.85026 7.66462 10.6457C7.66462 10.8836 7.60514 11.1141 7.50106 11.3371C7.12936 11.917 6.44542 12.4522 5.25595 12.4745C4.07392 12.4448 3.38254 11.917 3.01083 11.3371C2.95136 11.2107 2.90676 11.0843 2.87702 10.9505L0.200722 11.7534C0.282498 11.9913 0.386576 12.2218 0.505523 12.4448C1.04078 13.4633 2.04439 14.4223 3.76168 14.8014C4.2003 14.9055 4.66122 14.965 5.137 14.965C5.17417 14.965 5.21135 14.965 5.24852 14.965C5.28569 14.965 5.32286 14.965 5.36003 14.965C5.83581 14.965 6.29673 14.9055 6.73535 14.8014C8.45264 14.4297 9.45625 13.4633 9.99151 12.4448C10.326 11.85 10.5119 11.1735 10.5119 10.4524C10.5119 9.22579 10.0212 8.21474 9.17375 7.4862Z"></path><path d="M48.9156 1.70947V5.72392C48.6256 5.19609 47.8004 4.49728 46.0385 4.49728C43.1615 4.49728 41.1543 6.77213 41.1543 9.67889C41.1543 12.6823 43.2284 14.8977 46.1277 14.8977C47.4956 14.8977 48.529 14.2955 48.9825 13.5075C48.9825 13.9684 49.0419 14.4516 49.0865 14.6598H51.7182C51.6736 14.2583 51.6365 13.5298 51.6365 12.8681V1.71691H48.9156V1.70947ZM46.4474 12.4964C44.9978 12.4964 43.9198 11.4482 43.9198 9.67146C43.9198 7.89469 45.0349 6.89108 46.4474 6.89108C47.8525 6.89108 48.9527 7.87982 48.9527 9.65659C48.9527 11.4482 47.8525 12.4964 46.4474 12.4964Z"></path><path d="M63.9861 5.3378V4.98096H61.347V5.34523V10.1849C61.347 11.471 60.2914 12.5266 59.0053 12.5266H58.7897C57.5036 12.5266 56.4479 11.471 56.4479 10.1849V10.1254V10.118V10.1105V9.95441V5.34523V4.98839H53.6973V5.35266V9.95441C53.6973 9.96928 53.6973 9.99158 53.6973 10.0064C53.6973 12.7868 55.7268 14.8238 58.4403 14.8238C59.9122 14.8238 60.8638 14.1993 61.2801 13.5525V14.2811C61.2801 16.1991 60.3062 17.0466 58.5666 17.0466C57.2657 17.0466 56.3736 16.2586 56.1877 15.1732L53.7047 15.82C53.9946 17.7157 55.8606 19.4107 58.6558 19.4107C62.4844 19.4107 64.001 16.9276 64.001 14.2067L63.9861 5.3378Z"></path></svg>');
const li = {
  hash: "svelte-172b6ih",
  code: `.steady_logo.svelte-172b6ih {width:51.1px;height:15.5px;}
@media (min-width: 768px) {.steady_logo.svelte-172b6ih {width:57.6px;height:18px;}
}`
};
function oi(e, t) {
  nt(e, li);
  let a = Ze(t, "color", 3, "#CBC9C9");
  var n = ii(), s = p(n), r = m(s), i = m(r), l = m(i), c = m(l), o = m(c);
  D(() => {
    N(s, "fill", a()), N(r, "fill", a()), N(i, "fill", a()), N(l, "fill", a()), N(c, "fill", a()), N(o, "fill", a());
  }), A(e, n);
}
const ut = cn({}), gs = 190, ci = Gr(
  ut,
  (e, t, a) => {
    a((n) => {
      if (Object.keys(e).length > 0) {
        for (const [s, r] of Object.entries(e)) {
          const { expanded: i } = r, l = r.clientHeight > gs;
          n[s] = l && !i;
        }
        return n;
      } else
        return {};
    });
  },
  {}
), za = (e, { index: t, planName: a, rowNumber: n }) => {
  const s = t, r = n, i = a;
  let l = !0, c = () => {
  }, o = ia(e.clientHeight, {
    duration: 400,
    easing: Ra
  });
  return document.fonts.ready.then(() => {
    ut.update((d) => (d[i] = {
      clientHeight: e.clientHeight,
      savedRowNumber: r,
      expanded: !1
    }, d)), e.clientHeight > gs && (e.style.height = "140px"), o = ia(e.clientHeight, {
      duration: 400,
      easing: Ra
    }), c = o.subscribe((d) => {
      if (l) {
        l = !1;
        return;
      }
      e.style.height = `${d}px`;
    }), e.parentElement && (e.parentElement.style.maxHeight = "none");
  }).catch(() => {
  }), {
    update: (d) => {
      var f, _;
      if (d.isTabletOrLarger && d.rowNumber === r) {
        const v = Object.values(Ma(ut)).filter(
          (b) => b.savedRowNumber === r
        ), h = v.length > 1 ? Math.max(...v.map((b) => b.clientHeight)) : ((f = v[0]) == null ? void 0 : f.clientHeight) ?? 0;
        ut.update((b) => {
          let { [i]: k } = b;
          return k ? (k = {
            ...k,
            expanded: !0
          }, { ...b, [i]: k }) : b;
        }), o.set(h).then(c).catch(() => {
        });
      } else !d.isTabletOrLarger && s === d.index && (ut.update((v) => {
        let { [i]: h } = v;
        return h ? (h = {
          ...h,
          expanded: !0
        }, { ...v, [i]: h }) : v;
      }), o.set(((_ = Ma(ut)[i]) == null ? void 0 : _.clientHeight) ?? 0).then(c).catch(() => {
      }));
    },
    destroy: c
  };
}, _i = (e, t) => {
  j(t, u(t) === "monthly" ? "annual" : "monthly", !0);
};
var di = /* @__PURE__ */ U('<div class="steady_checkout__plan_toggle svelte-19b0ic4"><label aria-hidden="true" for="steady_plan_period_toggle"> </label> <button id="steady_plan_period_toggle"><i aria-hidden="true" class="svelte-19b0ic4"></i></button> <label aria-hidden="true" for="steady_plan_period_toggle"> </label></div>'), ui = /* @__PURE__ */ U('<div class="steady_checkout__subscription__plans__item__image svelte-19b0ic4" aria-hidden="true"><img width="280" height="140" alt="" class="svelte-19b0ic4"></div>'), vi = /* @__PURE__ */ U('<li class="svelte-19b0ic4"><i aria-hidden="true" class="svelte-19b0ic4"><!></i> <span class="svelte-19b0ic4"> </span></li>'), fi = /* @__PURE__ */ U('<li class="svelte-19b0ic4"><i aria-hidden="true" class="svelte-19b0ic4"><!></i> <span class="svelte-19b0ic4"> </span></li>'), hi = /* @__PURE__ */ U("<ul><!> <!></ul>"), pi = /* @__PURE__ */ U('<button aria-hidden="true" class="steady_checkout__subscription__plans__item__content__benefits__show_more svelte-19b0ic4"> </button>'), wi = (e, t, a, n) => {
  t.startPlanSteadyFlow(u(a).ctaUrl, u(n));
}, yi = /* @__PURE__ */ U('<div class="steady_checkout__subscription__plans__item svelte-19b0ic4"><!> <div class="steady_checkout__subscription__plans__item__content svelte-19b0ic4"><h2> </h2> <div class="steady_checkout__subscription__plans__item__content__price_info__sr_only svelte-19b0ic4"> </div> <p aria-hidden="true" class="steady_checkout__subscription__plans__item__content__price_info svelte-19b0ic4"><span class="steady_checkout__subscription__plans__item__content__price_info__price svelte-19b0ic4"> </span> <span class="steady_checkout__subscription__plans__item__content__price_info__period svelte-19b0ic4"> </span></p> <p> </p> <div class="steady_checkout__subscription__plans__item__content__benefits__wrapper svelte-19b0ic4"><!> <!></div></div> <button> </button></div>'), bi = /* @__PURE__ */ U('<button data-testid="gift_membership_cta"><span aria-hidden="true" class="svelte-19b0ic4">🎁&nbsp;</span> </button>'), gi = /* @__PURE__ */ U('<section id="steady_checkout" data-testid="steady_checkout_container" class="svelte-19b0ic4"><!> <div class="steady_checkout__subscription svelte-19b0ic4"><div class="steady_checkout__subscription__plans svelte-19b0ic4"></div> <div class="steady_checkout__subscription__membership svelte-19b0ic4"><!></div></div> <div class="steady_checkout__steady svelte-19b0ic4"><p aria-hidden="true" class="steady_checkout__steady__managed_by svelte-19b0ic4"> </p> <i aria-hidden="true" class="svelte-19b0ic4"><!></i> <span class="steady_checkout__steady__sr_only svelte-19b0ic4"> </span></div></section>');
const mi = {
  hash: "svelte-19b0ic4",
  code: `
#steady_checkout.svelte-19b0ic4 {all:initial;box-sizing:border-box;}
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4):where(:not(html, iframe, canvas, svg, video, audio):not(svg *, symbol *)) {all:unset;display:revert;}
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4),
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4)::before,
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4)::after {box-sizing:border-box;}
#steady_checkout.svelte-19b0ic4 button:where(.svelte-19b0ic4) {cursor:pointer;}
#steady_checkout.svelte-19b0ic4 ul:where(.svelte-19b0ic4) {list-style:none;}
#steady_checkout.svelte-19b0ic4 img:where(.svelte-19b0ic4) {max-inline-size:100%;max-block-size:100%;margin:0;padding:0;overflow:clip;overflow-clip-margin:content-box;border:none;box-shadow:none;}
#steady_checkout.svelte-19b0ic4 :where(pre) {all:revert;box-sizing:border-box;}
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4)::placeholder {color:unset;}
#steady_checkout.svelte-19b0ic4 :where([contenteditable]:not([contenteditable="false"])) {-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto;}
#steady_checkout.svelte-19b0ic4 :where([draggable="true"]) {-webkit-user-drag:element;}
#steady_checkout.svelte-19b0ic4 :where(dialog:modal) {all:revert;box-sizing:border-box;}
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4)::-webkit-details-marker {display:none;}
#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4):focus-visible {outline:revert;}#steady_checkout.svelte-19b0ic4 {container:checkout-section/inline-size;display:flex;flex-direction:column;align-items:center;width:100%;color:#271f36;font-size:12px;font-family:"CircularStd", Arial, sans-serif;line-height:16px;background:white;}
@container checkout-section (min-width: 768px) {#steady_checkout.svelte-19b0ic4 :where(.svelte-19b0ic4) {font-size:15px;line-height:20px;}
}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription:where(.svelte-19b0ic4) {display:grid;align-items:stretch;justify-items:center;padding:0 20px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans:where(.svelte-19b0ic4) {display:grid;gap:20px;align-items:stretch;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item:where(.svelte-19b0ic4) {display:flex;flex-direction:column;min-width:210px;max-width:280px;border:1px solid #ded8d8;border-radius:13px 13px 0 0;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__image:where(.svelte-19b0ic4) {overflow:hidden;line-height:0;border-radius:13px 13px 0 0;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content:where(.svelte-19b0ic4) {flex-grow:1;padding:10px 15px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__name:where(.svelte-19b0ic4) {align-content:flex-end;margin-bottom:10px;font-size:15px;line-height:24px;overflow-wrap:anywhere;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info:where(.svelte-19b0ic4) {margin-bottom:10px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__sr_only:where(.svelte-19b0ic4) {position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;text-transform:unset;-webkit-user-select:none;user-select:none;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__price:where(.svelte-19b0ic4) {font-size:30px;line-height:24px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__period:where(.svelte-19b0ic4) {color:#979797;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__annual:where(.svelte-19b0ic4) {margin-bottom:20px;color:var(--cta-color);}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__annual--short:where(.svelte-19b0ic4) {margin-bottom:10px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits:where(.svelte-19b0ic4) {position:relative;padding:15px 0 5px;overflow:hidden;overflow-wrap:anywhere;border-top:1px solid #ded8d8;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits:where(.svelte-19b0ic4)::after {position:absolute;right:0;bottom:-100px;left:0;display:block;height:100px;background:linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, white 100%);transition:0.5s ease bottom;content:"";}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits--greyed_out:where(.svelte-19b0ic4)::after {bottom:0;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__wrapper:where(.svelte-19b0ic4) {max-height:180px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__show_more:where(.svelte-19b0ic4) {display:flex;align-items:center;font-weight:500;font-size:13px;letter-spacing:0.5px;white-space:normal;text-transform:uppercase;overflow-wrap:break-word;}
@media (min-width: 768px) {#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__show_more:where(.svelte-19b0ic4) {white-space:nowrap;overflow-wrap:normal;}
}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__show_more:where(.svelte-19b0ic4):where(:where(.svelte-19b0ic4):hover, :where(.svelte-19b0ic4):focus) {opacity:80%;}
@media (min-width: 768px) {#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__show_more:where(.svelte-19b0ic4) {white-space:normal;overflow-wrap:break-word;}
}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__show_more:where(.svelte-19b0ic4) {padding:10px;transition:color 0.2s ease;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__show_more:where(.svelte-19b0ic4):hover {color:#585266;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits:where(.svelte-19b0ic4) li:where(.svelte-19b0ic4) {display:flex;align-items:start;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits:where(.svelte-19b0ic4) li:where(.svelte-19b0ic4):not(:last-child) {margin-bottom:5px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits:where(.svelte-19b0ic4) span:where(.svelte-19b0ic4) {flex-grow:1;margin-left:8px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4) {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative;z-index:1;height:50px;padding:0 15px;font-weight:500;font-size:13px;letter-spacing:0.5px;text-align:center;text-transform:uppercase;background-color:var(--brand-color);cursor:pointer;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta.light_brand_color:where(.svelte-19b0ic4) {color:#271f36;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta.dark_brand_color:where(.svelte-19b0ic4) {color:#ffffff;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4):hover:before {width:100%;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4):before {position:absolute;bottom:0;left:0;z-index:-1;width:0%;height:100%;background-color:var(--brand-color-darken);transition:all 0.3s ease;content:"";}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4):disabled {cursor:default;color:#ebebf7;border:1px solid #9a95a6;background-color:#9a95a6;box-shadow:0 0 0;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4):disabled:hover {cursor:default;color:#ebebf7;border:1px solid #9a95a6;background-color:#9a95a6;box-shadow:0 0 0;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4):disabled {color:#ebebf7;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4):disabled:before {content:none;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership:where(.svelte-19b0ic4) {display:flex;justify-content:center;width:100%;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership__gift:where(.svelte-19b0ic4) {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative;color:transparent;font-weight:500;font-size:13px;letter-spacing:0.5px;text-align:center;text-transform:uppercase;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership__gift.light_brand_color:where(.svelte-19b0ic4) {color:var(--brand-color-darken);border:1px solid var(--brand-color-darken);}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership__gift.dark_brand_color:where(.svelte-19b0ic4) {color:var(--brand-color);border:1px solid var(--brand-color);}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership__gift:where(.svelte-19b0ic4):hover {opacity:80%;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership__gift:where(.svelte-19b0ic4) {width:100%;height:50px;margin-top:20px;padding:0 15px;background-color:white;}
@container checkout-section (min-width: 768px) {#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans:where(.svelte-19b0ic4) {grid-template-rows:repeat(6, auto);grid-template-columns:repeat(3, minmax(225px, 1fr));max-width:880px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans:where(.svelte-19b0ic4):has(> div:where(.svelte-19b0ic4):nth-child(2):last-child) {grid-template-columns:repeat(2, 280px);justify-content:center;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans:where(.svelte-19b0ic4):has(> div:where(.svelte-19b0ic4):nth-child(2):last-child) + .steady_checkout__subscription__membership:where(.svelte-19b0ic4) > .steady_checkout__subscription__membership__gift:where(.svelte-19b0ic4) {min-width:calc((100% - 20px) / 2);}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item:where(.svelte-19b0ic4) {display:grid;grid-template-rows:subgrid;gap:0;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item:where(.svelte-19b0ic4):nth-child(3n+1) {grid-row:span 6;grid-column:1;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item:where(.svelte-19b0ic4):nth-child(3n+2) {grid-row:span 6;grid-column:2;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item:where(.svelte-19b0ic4):nth-child(3n+3) {grid-row:span 6;grid-column:3;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item:where(.svelte-19b0ic4):nth-child(3n+1):last-child {grid-column:2;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__image:where(.svelte-19b0ic4) {grid-row:1;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content:where(.svelte-19b0ic4) {display:contents;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content:where(.svelte-19b0ic4) > :where(.svelte-19b0ic4) {padding-right:15px;padding-left:15px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__name:where(.svelte-19b0ic4) {grid-row:2;margin:25px 0 15px;font-size:20px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__name--2rows:where(.svelte-19b0ic4) {grid-row:1/span 2;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info:where(.svelte-19b0ic4) {grid-row:3;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__price:where(.svelte-19b0ic4) {font-size:36px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__price_info__annual:where(.svelte-19b0ic4) {grid-row:4;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits:where(.svelte-19b0ic4) {padding:30px 0 20px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits--greyed_out:where(.svelte-19b0ic4) {padding-bottom:5px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__content__benefits__wrapper:where(.svelte-19b0ic4) {grid-row:5;max-height:190px;padding-bottom:10px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__plans__item__cta:where(.svelte-19b0ic4) {grid-row:6;}#steady_checkout.svelte-19b0ic4 .steady_checkout__subscription__membership__gift:where(.svelte-19b0ic4) {width:fit-content;min-width:calc((100% - 40px) / 3);}
}#steady_checkout.svelte-19b0ic4 .steady_checkout__steady:where(.svelte-19b0ic4) {display:flex;padding-top:20px;color:#cbc9c9;}#steady_checkout.svelte-19b0ic4 .steady_checkout__steady__managed_by:where(.svelte-19b0ic4) {margin-right:7px;transform:translateY(-1.6px);}#steady_checkout.svelte-19b0ic4 .steady_checkout__steady__sr_only:where(.svelte-19b0ic4) {position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;text-transform:unset;-webkit-user-select:none;user-select:none;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle:where(.svelte-19b0ic4) {display:flex;align-items:center;margin-bottom:30px;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle__option:where(.svelte-19b0ic4) {color:color-mix(in srgb, currentColor 60%, transparent 40%);font-size:13px;letter-spacing:0.52px;text-transform:uppercase;cursor:pointer;transition:color 0.2s ease;pointer-events:all;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle__option:where(.svelte-19b0ic4):hover {color:currentColor;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle__option--selected:where(.svelte-19b0ic4) {color:currentColor;cursor:default;pointer-events:none;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle:where(.svelte-19b0ic4) button:where(.svelte-19b0ic4) {position:relative;width:46px;height:26px;margin:0 10px;background-color:var(--brand-color);border-radius:23px;cursor:pointer;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle:where(.svelte-19b0ic4) button:where(.svelte-19b0ic4) i:where(.svelte-19b0ic4) {position:absolute;top:0;left:0;width:22px;height:22px;background-color:white;border-radius:11px;box-shadow:0 2px 2px rgba(0, 0, 0, 0.24);transform:translate3d(2px, 2px, 0);transition:all 0.2s ease-in-out;content:"";pointer-events:none;}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle:where(.svelte-19b0ic4) button:where(.svelte-19b0ic4):active i:where(.svelte-19b0ic4) {width:28px;transform:translate3d(2px, 2px, 0);}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle:where(.svelte-19b0ic4) button:active.steady_checkout__plan_toggle--annual_selected:where(.svelte-19b0ic4) i:where(.svelte-19b0ic4) {transform:translate3d(16px, 2px, 0);}#steady_checkout.svelte-19b0ic4 .steady_checkout__plan_toggle:where(.svelte-19b0ic4) button.steady_checkout__plan_toggle--annual_selected:where(.svelte-19b0ic4) i:where(.svelte-19b0ic4) {transform:translate3d(22px, 2px, 0);}`
};
function ms(e, t) {
  gt(t, !0), nt(e, mi);
  const [a, n] = vs(), s = () => Ha(ci, "$expandButtonRenderStateStore", a);
  let r = Ze(t, "standalone", 3, !0), i = X(void 0);
  const l = window.SteadyWidgetSettings, c = (x) => t.oauth.hasAccess && t.oauth.subscriptionPlanId ? x.id === t.oauth.subscriptionPlanId ? l.localization.planActive : l.localization.planChange : x.ctaText, o = (x) => t.oauth.hasAccess && t.oauth.subscriptionPlanId ? x.id === t.oauth.subscriptionPlanId : !1;
  let d;
  l.publicationOfferedPlanPeriods === "all" ? d = l.checkoutPeriodDefaultsToAnnual ? "annual" : "monthly" : d = l.publicationOfferedPlanPeriods;
  let f = X(Qe(d));
  const _ = (x) => {
    const w = l.localization.billedAnnually.replace("ANNUAL_AMOUNT", x.annualAmount);
    if (l.publicationOfferedPlanPeriods === "all" && x.annualSavingPercentage > 0) {
      const P = l.localization.annualSavingPercentage.replace("SAVING_PERCENTAGE", String(x.annualSavingPercentage));
      return w + " - " + P;
    } else
      return w;
  }, v = l.publicationPlans.some((x) => x.giftable), h = (x) => x.benefits && x.benefits.trim() !== "" ? x.benefits.split(/[\r\n]+/) : [];
  let b = X(null);
  const k = (x, w) => (j(
    b,
    {
      isTabletOrLarger: u(i) && u(i).offsetWidth > 768,
      index: x,
      rowNumber: Math.floor(x / 3),
      planName: w
    },
    !0
  ), {}), g = Ts(t.oauth, "checkout");
  Ft(() => {
    r() && Vt(t.oauth, "checkout", "loaded"), r() && u(i) && g.observe(u(i));
  }), ln(() => {
    r() && u(i) && g.unobserve(u(i));
  });
  var z = gi();
  let S;
  var T = p(z);
  {
    var y = (x) => {
      var w = di(), I = p(w);
      let P;
      var ne = p(I), de = m(I, 2);
      de.__click = [_i, f];
      let ue;
      var ge = m(de, 2);
      let ve;
      var Y = p(ge);
      D(
        (le, me, fe) => {
          P = Be(I, 1, "steady_checkout__plan_toggle__option svelte-19b0ic4", null, P, le), L(ne, l.localization.monthly), N(de, "aria-label", u(f) === "annual" ? l.localization.annual : l.localization.monthly), N(de, "data-testid", `steady_checkout_plan_toggle_${u(f)}`), ue = Be(de, 1, "svelte-19b0ic4", null, ue, me), ve = Be(ge, 1, "steady_checkout__plan_toggle__option svelte-19b0ic4", null, ve, fe), L(Y, l.localization.annual);
        },
        [
          () => ({
            "steady_checkout__plan_toggle__option--selected": u(f) === "monthly"
          }),
          () => ({
            "steady_checkout__plan_toggle--annual_selected": u(f) === "annual"
          }),
          () => ({
            "steady_checkout__plan_toggle__option--selected": u(f) === "annual"
          })
        ]
      ), A(x, w);
    };
    J(T, (x) => {
      l.publicationOfferedPlanPeriods === "all" && x(y);
    });
  }
  var M = m(T, 2), $ = p(M);
  na($, 23, () => l.publicationPlans, (x) => x.name, (x, w, I) => {
    var P = yi(), ne = p(P);
    {
      var de = (oe) => {
        var ce = ui(), Te = p(ce);
        D(() => N(Te, "src", u(w).image)), A(oe, ce);
      };
      J(ne, (oe) => {
        u(w).image && oe(de);
      });
    }
    var ue = m(ne, 2), ge = p(ue);
    let ve;
    var Y = p(ge), le = m(ge, 2), me = p(le), fe = m(le, 2), Ke = p(fe), Xe = p(Ke), st = m(Ke, 2), kt = p(st), Ie = m(fe, 2);
    let Ue, rt;
    var Je = p(Ie), it = m(Ie, 2), lt = p(it);
    {
      var Ct = (oe) => {
        var ce = hi();
        let Te;
        var V = p(ce);
        {
          var _e = (C) => {
            var E = vi(), K = p(E), se = p(K);
            la(se, { color: "var(--cta-color)" });
            var H = m(K, 2), ae = p(H);
            D(() => L(ae, u(w).maxGuestsInfo)), A(C, E);
          };
          J(V, (C) => {
            u(w).maxGuestsInfo && C(_e);
          });
        }
        var he = m(V, 2);
        na(he, 17, () => h(u(w)), nn, (C, E, K, se) => {
          var H = ga(), ae = Ge(H);
          {
            var pe = (we) => {
              var ct = fi(), Tt = p(ct), Es = p(Tt);
              la(Es, { color: "var(--cta-color)" });
              var As = m(Tt, 2), Ls = p(As);
              D(() => L(Ls, u(E))), A(we, ct);
            };
            J(ae, (we) => {
              u(E).trim() !== "" && we(pe);
            });
          }
          A(C, H);
        }), Mr(ce, (C, E) => za == null ? void 0 : za(C, E), () => u(b) ?? {
          index: u(I),
          rowNumber: Math.floor(u(I) / 3),
          planName: u(w).name
        }), D(
          (C) => {
            Te = Be(ce, 1, "steady_checkout__subscription__plans__item__content__benefits svelte-19b0ic4", null, Te, C), N(ce, "data-testid", `steady_checkout_${u(w).name}_plan_benefits`);
          },
          [
            () => ({
              "steady_checkout__subscription__plans__item__content__benefits--greyed_out": s()[u(w).name]
            })
          ]
        ), A(oe, ce);
      };
      J(lt, (oe) => {
        (u(w).maxGuestsInfo || h(u(w)).length > 0) && oe(Ct);
      });
    }
    var zt = m(lt, 2);
    {
      var ot = (oe) => {
        var ce = pi();
        ce.__click = () => {
          k(u(I), u(w).name);
        };
        var Te = p(ce);
        D(() => L(Te, l.localization.showMore)), A(oe, ce);
      };
      J(zt, (oe) => {
        s()[u(w).name] && oe(ot);
      });
    }
    var De = m(ue, 2);
    De.__click = [wi, t, w, f];
    var St = p(De);
    D(
      (oe, ce, Te, V, _e, he) => {
        ve = Be(ge, 1, "steady_checkout__subscription__plans__item__content__name svelte-19b0ic4", null, ve, oe), L(Y, u(w).name), L(me, `${u(f) === "monthly" ? u(w).monthlyAmount : u(w).annualAmountPerMonth} ${l.localization.perMonth}`), N(Ke, "data-testid", `steady_checkout_${u(w).name}_plan_price`), L(Xe, u(f) === "monthly" ? u(w).monthlyAmount : u(w).annualAmountPerMonth), L(kt, l.localization.perMonth), Ue = Be(Ie, 1, "steady_checkout__subscription__plans__item__content__price_info__annual svelte-19b0ic4", null, Ue, ce), rt = Ae(Ie, "", rt, {
          visibility: u(f) === "annual" ? "visible" : "hidden"
        }), L(Je, Te), Be(De, 1, V, "svelte-19b0ic4"), De.disabled = _e, N(De, "data-testid", `steady_checkout_${u(w).name}_plan_flow`), L(St, he);
      },
      [
        () => ({
          "steady_checkout__subscription__plans__item__content__name--2rows": !u(w).image
        }),
        () => ({
          "steady_checkout__subscription__plans__item__content__price_info__annual--short": !u(w).maxGuestsInfo && h(u(w)).length === 0
        }),
        () => _(u(w)),
        () => `steady_checkout__subscription__plans__item__cta
                      ${Ba(l.publicationBrandColor) ? "light_brand_color" : "dark_brand_color"}`,
        () => o(u(w)),
        () => c(u(w))
      ]
    ), A(x, P);
  });
  var q = m($, 2), te = p(q);
  {
    var G = (x) => {
      var w = bi();
      w.__click = function(...P) {
        var ne;
        (ne = t.startGiftPlansSteadyFlow) == null || ne.apply(this, P);
      };
      var I = m(p(w));
      D(
        (P) => {
          Be(w, 1, P, "svelte-19b0ic4"), L(I, ` ${l.localization.giftAMembership ?? ""}`);
        },
        [
          () => `steady_checkout__subscription__membership__gift
                    ${Ba(l.publicationBrandColor) ? "light_brand_color" : "dark_brand_color"}`
        ]
      ), A(x, w);
    };
    J(te, (x) => {
      v && x(G);
    });
  }
  var R = m(M, 2), Z = p(R), re = p(Z), ie = m(Z, 2), F = p(ie);
  oi(F, {});
  var O = m(ie, 2), Q = p(O);
  rn(z, (x) => j(i, x), () => u(i)), D(
    (x, w) => {
      S = Ae(z, "", S, {
        margin: r() ? "60px 0" : "0",
        border: r() ? "1px solid #ded8d8" : "",
        padding: r() ? "60px 0" : "70px 0 10px",
        "--brand-color": l.publicationBrandColor,
        "--brand-color-darken": x,
        "--cta-color": w
      }), L(re, l.localization.madeWith), L(Q, l.localization.madeWithSteady);
    },
    [
      () => ws(l.publicationBrandColor),
      () => ma(l.publicationBrandColor)
    ]
  ), A(e, z), mt(), n();
}
xt(["click"]);
var xi = /* @__PURE__ */ ba('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197 197" fill="none"><path d="M30.1622 29.6102L58.9593 1.94342L98.8903 1.46544L138.816 2.26467L167.39 30.1622L195.057 58.9592L195.534 98.8902L194.735 138.816L166.838 167.39L138.041 195.056L98.1097 195.534L58.1837 194.735L29.6102 166.838L1.94345 138.041L1.46548 98.1096L2.2647 58.1837L30.1622 29.6102Z" fill="none" stroke-width="2"></path><path transform="translate(10,10)" d="M26.7796 26.2821L52.7372 1.34333L88.731 0.912482L124.72 1.63289L150.476 26.7797L175.415 52.7372L175.846 88.731L175.125 124.72L149.979 150.476L124.021 175.415L88.0272 175.846L52.0381 175.125L26.282 149.979L1.34327 124.021L0.912415 88.0273L1.63283 52.0382L26.7796 26.2821Z"></path><g transform="translate(66,48)"><path d="M40.0366 55.5091L39.9749 51.9179V7.95633C39.9749 4.42702 37.1063 1.54785 33.59 1.54785C31.8318 1.54785 30.2279 2.2599 29.0866 3.43634C27.2668 5.26291 27.2051 7.5229 27.2051 7.95633C27.2051 11.4856 26.6499 32.5376 27.0817 55.4472L27.02 49.9055C27.02 46.6549 27.02 14.8292 27.02 11.6404C27.02 8.11112 24.1515 5.23195 20.6351 5.23195C18.877 5.23195 17.273 5.944 16.1318 7.12044C14.3119 8.94701 14.2502 11.207 14.2502 11.6404C14.2502 20.5566 14.2502 46.6239 14.2502 55.54V27.8938C14.2502 24.3645 11.3817 21.4853 7.86536 21.4853C4.34904 21.4853 1.48047 24.3645 1.48047 27.8938C1.48047 33.9617 1.48047 64.0537 1.48047 70.1216V69.2858V68.3879C1.48047 86.6537 16.2243 101.483 34.4228 101.483C52.6213 101.483 67.3651 86.6846 67.3651 68.3879H67.3343V42.754C67.3343 38.7604 64.0956 35.5097 60.1166 35.5097H59.7465C57.7415 35.5097 55.9525 36.3146 54.657 37.6149C52.5904 39.6891 52.5596 42.2587 52.5596 42.7231V67.8926V58.8526C52.5904 56.6855 52.5904 54.5184 52.5904 52.3513V11.7023C52.5904 8.17304 49.7219 5.29387 46.2055 5.29387C44.4474 5.29387 42.8435 6.00592 41.7022 7.18236C39.8823 9.00893 39.8207 11.2689 39.8207 11.7023" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>');
function Ln(e, t) {
  let a = Ze(t, "color", 3, "#4D4BF6"), n = Ze(t, "width", 3, 190), s = Ze(t, "height", 3, 190);
  var r = xi(), i = p(r), l = m(i);
  D(() => {
    N(r, "width", n()), N(r, "height", s()), N(i, "stroke", a()), N(l, "fill", a()), N(l, "stroke", a());
  }), A(e, r);
}
var ki = /* @__PURE__ */ ba('<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.47577 2L2 2.45701L6.13712 6.43096L6.375 6.64953L6.61288 6.43096L10.75 2.45701L10.2742 2L6.375 5.74546L2.47577 2Z" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
function xs(e, t) {
  let a = Ze(t, "color", 3, "#271f36");
  var n = ki(), s = p(n);
  D(() => {
    N(s, "fill", a()), N(s, "stroke", a());
  }), A(e, n);
}
/*! js-cookie v3.0.5 | MIT */
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];
    for (var n in a)
      e[n] = a[n];
  }
  return e;
}
var Ci = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Va(e, t) {
  function a(s, r, i) {
    if (!(typeof document > "u")) {
      i = Gt({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), s = encodeURIComponent(s).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var l = "";
      for (var c in i)
        i[c] && (l += "; " + c, i[c] !== !0 && (l += "=" + i[c].split(";")[0]));
      return document.cookie = s + "=" + e.write(r, s) + l;
    }
  }
  function n(s) {
    if (!(typeof document > "u" || arguments.length && !s)) {
      for (var r = document.cookie ? document.cookie.split("; ") : [], i = {}, l = 0; l < r.length; l++) {
        var c = r[l].split("="), o = c.slice(1).join("=");
        try {
          var d = decodeURIComponent(c[0]);
          if (i[d] = e.read(o, d), s === d)
            break;
        } catch {
        }
      }
      return s ? i[s] : i;
    }
  }
  return Object.create(
    {
      set: a,
      get: n,
      remove: function(s, r) {
        a(
          s,
          "",
          Gt({}, r, {
            expires: -1
          })
        );
      },
      withAttributes: function(s) {
        return Va(this.converter, Gt({}, this.attributes, s));
      },
      withConverter: function(s) {
        return Va(Gt({}, this.converter, s), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
Va(Ci, { path: "/" });
const zi = [
  "BUTTON",
  "A",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "MENU",
  "DETAILS",
  "SUMMARY",
  "COMMAND"
], Si = ["SCRIPT", "NOSCRIPT", "STEADY-PAYWALL"], Ti = 800, ks = "data-previous-aria-hidden", Cs = "data-previous-tabindex", Ei = 864e5, Ai = {
  ok: 200,
  created: 201,
  unauthorized: 401,
  serverError: 500
}, zs = { hasAccess: !1, isSubscriber: !1 }, jn = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", Li = async () => (
  // eslint-disable-next-line promise/avoid-new -- fix is a third party library which we don't want to use
  await new Promise((e) => {
    const t = new XMLHttpRequest();
    t.open("GET", jn, !0), t.onload = () => {
      t.readyState === t.DONE && (t.status === Ai.ok && t.responseText.length > 1 && t.responseURL === jn ? e(!1) : e(!0));
    }, t.onerror = () => {
      e(!0);
    }, t.send();
  })
), Ss = "steady-adblock-last-shown", ji = () => {
  localStorage.setItem(Ss, Date.now().toString());
}, Ii = (e) => !e.adblockFrequencyCappingActive || Pi(e), Pi = (e) => {
  const t = localStorage.getItem(Ss);
  return t ? Date.now() - Number(t) > Oi(e) : !0;
}, Oi = (e) => e.adblockFrequencyCappingDaysBetween * Ei;
var Mi = /* @__PURE__ */ U('<li class="svelte-zvsa6w"><span aria-hidden="true" class="steady_adblock__content__benefits__checkmark svelte-zvsa6w"><!></span> <span class="svelte-zvsa6w"> </span></li>'), Ni = /* @__PURE__ */ U('<ul class="steady_adblock__content__benefits svelte-zvsa6w"></ul>'), Hi = /* @__PURE__ */ U('<div id="adblock_checkout" class="svelte-zvsa6w"><!></div>'), Di = /* @__PURE__ */ U('<span class="svelte-zvsa6w"> </span> <button data-testid="steady_adblock_sign_out" class="svelte-zvsa6w"> </button>', 1), Bi = /* @__PURE__ */ U('<span class="svelte-zvsa6w"> </span> <button data-testid="steady_adblock_sign_in" class="svelte-zvsa6w"> </button>', 1), Ri = /* @__PURE__ */ U('<section id="steady_adblock_overlay" data-testid="steady_adblock_detector" class="svelte-zvsa6w"><div class="steady_adblock__box svelte-zvsa6w"><div class="steady_adblock svelte-zvsa6w"><div class="steady_adblock__main svelte-zvsa6w"><div aria-hidden="true" class="steady_adblock__image steady_adblock__image--desktop svelte-zvsa6w"><!></div> <div class="steady_adblock__content svelte-zvsa6w"><div class="steady_adblock__content__headline svelte-zvsa6w"><div aria-hidden="true" class="steady_adblock__image steady_adblock__image--mobile svelte-zvsa6w"><!></div> <h2 class="steady_adblock__content__headline__title svelte-zvsa6w"> </h2></div> <p class="steady_adblock__content__description svelte-zvsa6w"> </p> <!> <div class="steady_adblock__content__ctas svelte-zvsa6w"><button aria-controls="adblock_checkout" class="steady_adblock__content__cta svelte-zvsa6w" data-testid="steady_adblock_cta"><span class="steady_adblock__content__cta__text svelte-zvsa6w"> </span> <span class="steady_adblock__content__cta__arrow svelte-zvsa6w" aria-hidden="true" data-testid="steady_adblock_cta__arrow"><!></span></button></div></div></div> <!></div> <aside class="steady_adblock__auth svelte-zvsa6w"><!></aside> <!></div></section>');
const Fi = {
  hash: "svelte-zvsa6w",
  code: `#steady_adblock_overlay.svelte-zvsa6w {all:initial;box-sizing:border-box;}#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w):where(:not(html, iframe, canvas, svg, video, audio):not(svg *, symbol *)) {all:unset;display:revert;}#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w),
#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w)::before,
#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w)::after {box-sizing:border-box;}
#steady_adblock_overlay.svelte-zvsa6w button:where(.svelte-zvsa6w) {cursor:pointer;}
#steady_adblock_overlay.svelte-zvsa6w ul:where(.svelte-zvsa6w) {list-style:none;}#steady_adblock_overlay.svelte-zvsa6w :where(pre) {all:revert;box-sizing:border-box;}#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w)::placeholder {color:unset;}#steady_adblock_overlay.svelte-zvsa6w :where([contenteditable]:not([contenteditable="false"])) {-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto;}#steady_adblock_overlay.svelte-zvsa6w :where([draggable="true"]) {-webkit-user-drag:element;}#steady_adblock_overlay.svelte-zvsa6w :where(dialog:modal) {all:revert;box-sizing:border-box;}#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w)::-webkit-details-marker {display:none;}#steady_adblock_overlay.svelte-zvsa6w :where(.svelte-zvsa6w):focus-visible {outline:revert;}#steady_adblock_overlay.svelte-zvsa6w {position:absolute;right:0;left:0;z-index:2000;border-top:1px solid #e3e3e3;color:#271f36;font-size:12px;font-family:"CircularStd", Arial, sans-serif;line-height:16px;background:white;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w {font-size:15px;line-height:20px;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock:where(.svelte-zvsa6w) {padding:40px 20px 30px;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock:where(.svelte-zvsa6w) {padding:50px 40px 40px;}
}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__main:where(.svelte-zvsa6w) {display:flex;flex-direction:row;justify-content:center;column-gap:clamp(30px, 8vw, 100px);}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__box:where(.svelte-zvsa6w) {position:sticky;transform:translate3d(0, 0, 0);}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__image--desktop:where(.svelte-zvsa6w) {display:none;align-self:center;width:190px;height:190px;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__image--desktop:where(.svelte-zvsa6w) {display:block;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__image--mobile:where(.svelte-zvsa6w) {display:inline;width:60px;height:auto;margin-right:20px;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__image--mobile:where(.svelte-zvsa6w) {display:none;}
}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content:where(.svelte-zvsa6w) {max-width:500px;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__headline:where(.svelte-zvsa6w) {display:flex;align-items:center;margin-left:-5px;text-wrap:balance;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__headline:where(.svelte-zvsa6w) {margin-left:0;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__headline__title:where(.svelte-zvsa6w) {font-weight:500;font-size:20px;line-height:24px;letter-spacing:-1px;word-break:break-word;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__headline__title:where(.svelte-zvsa6w) {font-size:42px;line-height:44px;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__description:where(.svelte-zvsa6w) {margin:20px 0 15px 0;font-size:12px;line-height:16px;word-break:break-word;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__description:where(.svelte-zvsa6w) {font-size:15px;line-height:20px;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__benefits:where(.svelte-zvsa6w) {display:flex;flex-direction:column;gap:5px;width:fit-content;font-size:12px;line-height:16px;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__benefits:where(.svelte-zvsa6w) {display:grid;grid-template-columns:1fr 1fr;font-size:15px;line-height:20px;column-gap:20px;row-gap:5px;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__benefits__checkmark:where(.svelte-zvsa6w) {margin-right:8px;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__ctas:where(.svelte-zvsa6w) {display:flex;flex-wrap:wrap;justify-content:space-between;padding-top:20px;}
@media (min-width: 440px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__ctas:where(.svelte-zvsa6w) {justify-content:normal;column-gap:60px;}
}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__ctas:where(.svelte-zvsa6w) {padding-top:30px;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__cta:where(.svelte-zvsa6w) {gap:5px;width:fit-content;max-width:80%;display:flex;align-items:center;font-weight:500;font-size:13px;letter-spacing:0.5px;white-space:normal;text-transform:uppercase;overflow-wrap:break-word;}
@media (min-width: 768px) {#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__cta:where(.svelte-zvsa6w) {white-space:nowrap;overflow-wrap:normal;}
}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__cta:where(.svelte-zvsa6w):where(:where(.svelte-zvsa6w):hover, :where(.svelte-zvsa6w):focus) {opacity:80%;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__content__cta__text:where(.svelte-zvsa6w) {display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__auth:where(.svelte-zvsa6w) {display:flex;justify-content:center;padding:20px 0;color:#979797;border-top:1px solid #ded8d8;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__auth:where(.svelte-zvsa6w) button:where(.svelte-zvsa6w) {background:none;border:0;border-radius:0;-webkit-appearance:none;padding:0;text-align:inherit;color:inherit;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__auth:where(.svelte-zvsa6w) button:where(.svelte-zvsa6w):active {color:inherit;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__auth:where(.svelte-zvsa6w) button:where(.svelte-zvsa6w) {color:#291e38;font-weight:500;text-decoration:underline;cursor:pointer;transition:color 0.2s;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__auth:where(.svelte-zvsa6w) button:where(.svelte-zvsa6w):hover {color:#585266;}#steady_adblock_overlay.svelte-zvsa6w .steady_adblock__auth:where(.svelte-zvsa6w) button:where(.svelte-zvsa6w) {color:inherit;}`
};
function Vi(e, t) {
  gt(t, !0), nt(e, Fi);
  const [a, n] = vs(), s = () => Ha(y, "$overlayTopPositionState", a), r = () => Ha(T, "$overlayHeightState", a), i = window.SteadyWidgetSettings;
  let l = X(!1), c = X(!1), o = X(!1), d = X(0), f = 0, _ = X(void 0), v, h = X(!0);
  const b = () => {
    j(l, !1), v == null || v.disconnect(), window.removeEventListener("scroll", q);
  }, k = (F) => i.localization.signedInButNoSubscription.replace("EMAIL_ADDRESS", F), g = (F) => {
    const O = window.innerHeight, Q = O * (1 - F / 100), x = document.documentElement.offsetHeight, w = Math.max(x, O) - (O - Q);
    return F === 0 && u(_) && u(_).offsetHeight > w ? u(_).offsetHeight : w;
  }, z = 60;
  let S = X(z);
  const T = ia(g(z)), y = ia(z);
  let M = Aa(() => u(h) ? 0 : (1 - s() / u(S)) * 180);
  const $ = () => {
    const F = u(o) ? u(S) : 0, O = g(F);
    j(o, !u(o));
    const Q = { duration: 900, easing: Mt };
    Promise.all([
      T.set(O, Q),
      y.set(F, Q)
    ]);
  }, q = () => {
    var x;
    const F = window.innerHeight, O = (x = u(_)) == null ? void 0 : x.offsetHeight, Q = window.scrollY || document.documentElement.scrollTop;
    if (u(o) && O && O > F && O < r()) {
      const w = Q - f, I = w > 0, P = w < 0;
      I && u(d) > F - O ? j(d, Math.max(F - O, u(d) - Math.abs(w)), !0) : P && u(d) < 0 && j(d, Math.min(0, u(d) + Math.abs(w)), !0);
    } else
      j(d, 0);
    f = Q;
  }, te = () => {
    document.documentElement.style.height = "auto";
  }, G = bs(
    () => {
      const F = window.innerHeight;
      if (u(o) && u(_)) {
        const O = u(_).offsetHeight - u(_).querySelector("#steady_checkout").offsetHeight;
        j(S, Math.max((1 - O / F) * 100, 0), !0), T.set(g(0), { duration: 50 }).catch(() => {
        });
      } else if (u(_)) {
        const O = u(_).offsetHeight;
        j(S, Math.max(Math.floor((1 - O / F) * 100), 0), !0);
        const Q = g(u(S)), x = {
          duration: u(h) ? 500 : 50,
          easing: Mt
        };
        Promise.all([
          y.set(u(S), x),
          T.set(Q, x)
        ]).then(() => {
          u(h) && j(h, !1);
        }).catch(() => {
        });
      }
    },
    100
  ), R = /bot|crawler|spider|crawling/i.test(navigator.userAgent);
  Ft(async () => {
    if (!t.oauth.hasAccess && !R && Ii(i)) {
      try {
        j(l, await Li(), !0);
      } catch {
        j(l, !1);
      }
      "email" in t.oauth && t.oauth.email && j(c, t.oauth, !0), u(l) && ji(), await br(), u(l) && (Vt(t.oauth, "adblock", "shown"), te(), v = new ResizeObserver(G), u(_) && v.observe(u(_)), v.observe(document.documentElement), window.addEventListener("scroll", q, { passive: !0 }));
    }
  }), ln(() => {
    v == null || v.disconnect(), window.removeEventListener("scroll", q);
  });
  var Z = ga(), re = Ge(Z);
  {
    var ie = (F) => {
      var O = Ri();
      let Q;
      var x = p(O);
      let w;
      var I = p(x), P = p(I), ne = p(P), de = p(ne);
      Ln(de, {});
      var ue = m(ne, 2), ge = p(ue), ve = p(ge), Y = p(ve);
      Ln(Y, { width: 60, height: 60 });
      var le = m(ve, 2), me = p(le), fe = m(ge, 2), Ke = p(fe), Xe = m(fe, 2);
      {
        var st = (V) => {
          var _e = Ni();
          na(_e, 21, () => i.adblockBenefits, nn, (he, C) => {
            var E = Mi(), K = p(E), se = p(K);
            la(se, { color: "var(--cta-color)" });
            var H = m(K, 2), ae = p(H);
            D(() => L(ae, u(C))), A(he, E);
          }), A(V, _e);
        };
        J(Xe, (V) => {
          i.adblockBenefits && V(st);
        });
      }
      var kt = m(Xe, 2), Ie = p(kt);
      Ie.__click = $, Ae(Ie, "", {}, { color: "var(--cta-color)" });
      var Ue = p(Ie), rt = p(Ue), Je = m(Ue, 2);
      let it;
      var lt = p(Je);
      xs(lt, { color: "var(--cta-color)" });
      var Ct = m(P, 2);
      {
        var zt = (V) => {
          var _e = Hi(), he = p(_e);
          ms(he, {
            oauth: zs,
            standalone: !1,
            get startPlanSteadyFlow() {
              return t.startPlanSteadyFlow;
            },
            get startGiftPlansSteadyFlow() {
              return t.startGiftPlansSteadyFlow;
            }
          }), sa(3, _e, () => hs, () => ({ duration: 900, easing: Ra })), A(V, _e);
        };
        J(Ct, (V) => {
          u(o) && V(zt);
        });
      }
      var ot = m(I, 2), De = p(ot);
      {
        var St = (V) => {
          var _e = Di(), he = Ge(_e), C = p(he), E = m(he, 2);
          E.__click = function(...se) {
            var H;
            (H = t.signOut) == null || H.apply(this, se);
          };
          var K = p(E);
          D(
            (se) => {
              L(C, `${se ?? ""}  `), L(K, i.localization.signOut);
            },
            [
              () => k(u(c).email)
            ]
          ), A(V, _e);
        }, oe = (V) => {
          var _e = Bi(), he = Ge(_e), C = p(he), E = m(he, 2);
          E.__click = function(...se) {
            var H;
            (H = t.signIn) == null || H.apply(this, se);
          };
          var K = p(E);
          D(() => {
            L(C, `${i.localization.alreadyMember ?? ""}  `), L(K, i.localization.signIn);
          }), A(V, _e);
        };
        J(De, (V) => {
          u(c) ? V(St) : V(oe, !1);
        });
      }
      var ce = m(ot, 2);
      {
        var Te = (V) => {
          _n(V, { widgetSettings: i, close: b });
        };
        J(ce, (V) => {
          i.adblockDismissible && V(Te);
        });
      }
      rn(x, (V) => j(_, V), () => u(_)), D(
        (V) => {
          Q = Ae(O, "", Q, {
            top: `${s()}vh`,
            height: `${r()}px`,
            "--cta-color": V
          }), w = Ae(x, "", w, { top: `${u(d)}px` }), L(me, i.adblockHeadline), L(Ke, i.adblockDescription), N(Ie, "aria-expanded", `${u(o)}`), L(rt, i.adblockCtaText), it = Ae(Je, "", it, {
            transform: `rotate(${u(M)}deg)`
          });
        },
        [
          () => ma(i.publicationBrandColor)
        ]
      ), sa(5, O, () => fs, () => ({ duration: 500 })), A(F, O);
    };
    J(re, (F) => {
      u(l) && F(ie);
    });
  }
  A(e, Z), mt(), n();
}
xt(["click"]);
const bl = (e) => {
  class t extends HTMLElement {
    constructor() {
      super(...arguments);
      Wt(this, "_element", {});
    }
    connectedCallback() {
      const s = this.attachShadow({ mode: "open" });
      this._element = tn(Vi, {
        target: s,
        intro: !0,
        props: e
      });
    }
    disconnectedCallback() {
      an(this._element);
    }
  }
  customElements.define("steady-adblock", t);
};
nr();
xt(["click"]);
const Wi = "steady-newsletter-opted-in", Ui = (e, t, a) => {
  j(t, !u(t)), u(t) ? a.set(180, { duration: 900, easing: Mt }) : a.set(0, { duration: 900, easing: Mt });
};
var qi = /* @__PURE__ */ U('<p class="steady_paywall__description svelte-adefh3"> </p>'), $i = /* @__PURE__ */ U('<li class="svelte-adefh3"><span aria-hidden="true" class="steady_paywall__benefits__checkmark svelte-adefh3"><!></span> <span class="svelte-adefh3"> </span></li>'), Gi = /* @__PURE__ */ U('<ul class="steady_paywall__benefits svelte-adefh3"></ul>'), Zi = /* @__PURE__ */ U('<button aria-controls="paywall_checkout" class="steady_paywall__cta svelte-adefh3" data-testid="paywall_toggle_checkout"> <span aria-hidden="true" class="steady_paywall__cta__arrow_down svelte-adefh3"><!></span></button>'), Yi = /* @__PURE__ */ U('<a target="_blank" class="steady_paywall__cta svelte-adefh3" data-testid="paywall_link_to_checkout"> <!></a>'), Ki = /* @__PURE__ */ U('<button class="steady_paywall__cta svelte-adefh3" data-testid="paywall_cta"> <!></button>'), Xi = /* @__PURE__ */ U('<div id="paywall_checkout" class="svelte-adefh3"><!></div>'), Ji = /* @__PURE__ */ U('<p class="svelte-adefh3"> </p> <button data-testid="steady_paywall_sign_out" class="svelte-adefh3"> </button>', 1), Qi = /* @__PURE__ */ U('<p class="svelte-adefh3"> </p> <button data-testid="steady_paywall_sign_in" class="svelte-adefh3"> </button>', 1), el = /* @__PURE__ */ U('<section id="steady_paywall_overlay" data-testid="steady_paywall" class="svelte-adefh3"><div class="svelte-adefh3"></div> <div class="steady_paywall_overlay__container svelte-adefh3" data-testid="steady_paywall_overlay_container"><div role="alert" class="steady_paywall__alert svelte-adefh3"> </div> <div class="steady_paywall svelte-adefh3"><div class="steady_paywall__main svelte-adefh3"><img class="steady_paywall__image steady_paywall__image--desktop svelte-adefh3" aria-hidden="true" alt=""> <div class="steady_paywall__content svelte-adefh3"><div class="steady_paywall__headline svelte-adefh3"><img class="steady_paywall__image steady_paywall__image--mobile svelte-adefh3" aria-hidden="true" alt=""> <h2 class="svelte-adefh3"> </h2></div> <!> <!> <div class="steady_paywall__ctas svelte-adefh3"><!></div></div></div> <!></div> <aside class="steady_paywall__auth svelte-adefh3"><!></aside> <!></div></section>');
const tl = {
  hash: "svelte-adefh3",
  code: `
#steady_paywall_overlay.svelte-adefh3 {all:initial;box-sizing:border-box;}
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3):where(:not(html, iframe, canvas, svg, video, audio):not(svg *, symbol *)) {all:unset;display:revert;}
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3),
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3)::before,
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3)::after {box-sizing:border-box;}
#steady_paywall_overlay.svelte-adefh3 a:where(.svelte-adefh3),
#steady_paywall_overlay.svelte-adefh3 button:where(.svelte-adefh3) {cursor:pointer;}
#steady_paywall_overlay.svelte-adefh3 ul:where(.svelte-adefh3) {list-style:none;}
#steady_paywall_overlay.svelte-adefh3 img:where(.svelte-adefh3) {max-inline-size:100%;max-block-size:100%;margin:0;padding:0;overflow:clip;overflow-clip-margin:content-box;border:none;box-shadow:none;}
#steady_paywall_overlay.svelte-adefh3 :where(pre) {all:revert;box-sizing:border-box;}
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3)::placeholder {color:unset;}
#steady_paywall_overlay.svelte-adefh3 :where([contenteditable]:not([contenteditable="false"])) {-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto;}
#steady_paywall_overlay.svelte-adefh3 :where([draggable="true"]) {-webkit-user-drag:element;}
#steady_paywall_overlay.svelte-adefh3 :where(dialog:modal) {all:revert;box-sizing:border-box;}
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3)::-webkit-details-marker {display:none;}
#steady_paywall_overlay.svelte-adefh3 :where(.svelte-adefh3):focus-visible {outline:revert;}#steady_paywall_overlay.svelte-adefh3 {position:absolute;z-index:2000;display:block;-webkit-backdrop-filter:blur(8px) saturate(0.5);backdrop-filter:blur(8px) saturate(0.5);color:#271f36;font-size:12px;font-family:"CircularStd", Arial, sans-serif;line-height:16px;background:white;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 {font-size:15px;line-height:20px;}
}#steady_paywall_overlay.svelte-adefh3 {background:transparent;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall_overlay__container:where(.svelte-adefh3) {margin:0 auto;background:white;border:1px solid #ded8d8;transform:translate3d(0, 0, 0);}#steady_paywall_overlay.svelte-adefh3 .steady_paywall:where(.svelte-adefh3) {padding:40px 20px 30px;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall:where(.svelte-adefh3) {padding:50px 40px 40px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__alert:where(.svelte-adefh3) {position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0;text-transform:unset;-webkit-user-select:none;user-select:none;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__main:where(.svelte-adefh3) {display:flex;flex-direction:row;justify-content:center;column-gap:clamp(30px, 8vw, 100px);}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__image--desktop:where(.svelte-adefh3) {display:none;align-self:center;width:145px;height:145px;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__image--desktop:where(.svelte-adefh3) {display:block;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__image--mobile:where(.svelte-adefh3) {display:inline;width:50px;height:50px;margin-right:20px;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__image--mobile:where(.svelte-adefh3) {display:none;}
}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__content:where(.svelte-adefh3) {max-width:500px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__headline:where(.svelte-adefh3) {display:flex;align-items:center;text-wrap:balance;font-weight:500;font-size:20px;line-height:24px;letter-spacing:-1px;word-break:break-word;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__headline:where(.svelte-adefh3) {font-size:42px;line-height:44px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__headline:where(.svelte-adefh3) img:where(.svelte-adefh3) {flex:0 0 auto;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__description:where(.svelte-adefh3) {font-size:12px;line-height:16px;word-break:break-word;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__description:where(.svelte-adefh3) {font-size:15px;line-height:20px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__description:where(.svelte-adefh3) {margin-top:20px;margin-bottom:10px;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__description:where(.svelte-adefh3) {margin-top:15px;margin-bottom:15px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__benefits:where(.svelte-adefh3) {display:flex;flex-direction:column;gap:5px;width:fit-content;font-size:12px;line-height:16px;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__benefits:where(.svelte-adefh3) {display:grid;grid-template-columns:1fr 1fr;font-size:15px;line-height:20px;column-gap:20px;row-gap:5px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__benefits__checkmark:where(.svelte-adefh3) {margin-right:8px;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__ctas:where(.svelte-adefh3) {display:flex;flex-wrap:wrap;justify-content:space-between;padding-top:20px;}
@media (min-width: 440px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__ctas:where(.svelte-adefh3) {justify-content:normal;column-gap:60px;}
}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__ctas:where(.svelte-adefh3) {padding-top:30px;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__cta:where(.svelte-adefh3) {color:var(--cta-color);display:flex;align-items:center;font-weight:500;font-size:13px;letter-spacing:0.5px;white-space:normal;text-transform:uppercase;overflow-wrap:break-word;}
@media (min-width: 768px) {#steady_paywall_overlay.svelte-adefh3 .steady_paywall__cta:where(.svelte-adefh3) {white-space:nowrap;overflow-wrap:normal;}
}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__cta:where(.svelte-adefh3):where(:where(.svelte-adefh3):hover, :where(.svelte-adefh3):focus) {opacity:80%;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__cta__arrow_down:where(.svelte-adefh3) {display:inline-block;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__auth:where(.svelte-adefh3) {display:flex;justify-content:center;padding:20px 0;color:#979797;border-top:1px solid #ded8d8;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__auth:where(.svelte-adefh3) button:where(.svelte-adefh3) {background:none;border:0;border-radius:0;-webkit-appearance:none;padding:0;text-align:inherit;color:inherit;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__auth:where(.svelte-adefh3) button:where(.svelte-adefh3):active {color:inherit;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__auth:where(.svelte-adefh3) button:where(.svelte-adefh3) {color:#291e38;font-weight:500;text-decoration:underline;cursor:pointer;transition:color 0.2s;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__auth:where(.svelte-adefh3) button:where(.svelte-adefh3):hover {color:#585266;}#steady_paywall_overlay.svelte-adefh3 .steady_paywall__auth:where(.svelte-adefh3) button:where(.svelte-adefh3) {color:inherit;}`
};
function al(e, t) {
  gt(t, !0), nt(e, tl);
  const a = window.SteadyWidgetSettings, n = document.querySelector(`.${t.paywallContainerClass}`) ?? document.body, s = n === document.body, r = document.getElementById(t.markerId), i = new Fa(0), l = "email" in t.oauth && t.oauth.email ? t.oauth : !1;
  let c = X(0), o = X(0), d = Aa(() => Z() && u(c) > 1e3 ? "0px" : "unset"), f = Aa(() => Z() && u(c) > 1e3 ? "unset" : "0px"), _ = 5, v = 10, h = X("100%"), b = X(!t.oauth.hasAccess), k = X(!1), g = X(void 0), z, S = [];
  const T = (w) => a.localization.signedInButNoSubscription.replace("EMAIL_ADDRESS", w), y = () => {
    var ue;
    const w = oa(r), I = oa(n), P = n.offsetHeight, ne = ((ue = u(g)) == null ? void 0 : ue.offsetHeight) ?? 0, de = s ? Math.max(P, window.innerHeight - I, ne) : Math.max(P, ne);
    j(o, w - I - _), j(c, de + I - w + _);
  }, M = () => {
    n.style.paddingBottom = "0px";
  }, $ = () => {
    var P;
    M();
    const w = ((P = u(g)) == null ? void 0 : P.offsetHeight) ?? 0, I = n.offsetHeight - r.offsetTop;
    w > I ? (n.style.paddingBottom = `${w - I}px`, _ = 0) : _ = 5;
  }, q = () => {
    var w;
    j(h, `calc(100% - ${((w = u(g)) == null ? void 0 : w.offsetHeight) ?? 0}px)`);
  }, te = () => {
    j(b, !1), rl(S), M(), z == null || z.disconnect();
  }, G = bs(
    () => {
      $(), y(), q();
    },
    10
  ), R = (w) => {
    const I = getComputedStyle(w), P = w.style;
    return I.getPropertyValue("overflow-x") !== "visible" && I.getPropertyValue("overflow-x") !== "" || I.getPropertyValue("overflow-y") !== "visible" && I.getPropertyValue("overflow-y") !== "" || I.getPropertyValue("overflow") !== "visible" && I.getPropertyValue("overflow") !== "" || P.overflowX !== "visible" && P.overflowX !== "" || P.overflowY !== "visible" && P.overflowY !== "" || P.overflow !== "visible" && P.overflow !== "";
  }, Z = () => R(document.documentElement) || R(document.body), re = () => {
    s && (n.style.height = "auto");
  }, ie = s ? "paywall_bottom" : "paywall_in_between", F = Ts(t.oauth, ie);
  Ft(() => {
    re(), u(b) && (Vt(t.oauth, ie, "loaded"), u(g) && F.observe(u(g)), z = new ResizeObserver(G), u(g) && z.observe(u(g)), z.observe(n), !s && !a.paywallDismissible && (S = sl(r, n)));
  }), ln(() => {
    te(), u(g) && F.unobserve(u(g));
  });
  var O = ga(), Q = Ge(O);
  {
    var x = (w) => {
      var I = el();
      let P;
      var ne = p(I);
      let de;
      var ue = m(ne, 2);
      let ge;
      var ve = p(ue), Y = p(ve), le = m(ve, 2), me = p(le), fe = p(me);
      N(fe, "width", 50), N(fe, "height", 50);
      var Ke = m(fe, 2), Xe = p(Ke), st = p(Xe), kt = m(st, 2), Ie = p(kt), Ue = m(Xe, 2);
      {
        var rt = (C) => {
          var E = qi(), K = p(E);
          D(() => L(K, a.paywallDescription)), A(C, E);
        };
        J(Ue, (C) => {
          a.paywallDescription && C(rt);
        });
      }
      var Je = m(Ue, 2);
      {
        var it = (C) => {
          var E = Gi();
          na(E, 21, () => a.paywallBenefits, nn, (K, se) => {
            var H = $i(), ae = p(H), pe = p(ae);
            la(pe, { color: "var(--cta-color)" });
            var we = m(ae, 2), ct = p(we);
            D(() => L(ct, u(se))), A(K, H);
          }), A(C, E);
        };
        J(Je, (C) => {
          a.paywallBenefits && C(it);
        });
      }
      var lt = m(Je, 2), Ct = p(lt);
      {
        var zt = (C) => {
          var E = Zi();
          E.__click = [
            Ui,
            k,
            i
          ];
          var K = p(E), se = m(K);
          let H;
          var ae = p(se);
          xs(ae, { color: "var(--cta-color)" }), D(() => {
            N(E, "aria-expanded", `${u(k)}`), L(K, `${a.paywallCtaText ?? ""}   `), H = Ae(se, "", H, {
              transform: `rotate(${i.current}deg)`
            });
          }), A(C, E);
        }, ot = (C, E) => {
          {
            var K = (H) => {
              var ae = Yi(), pe = p(ae), we = m(pe);
              Da(we, { color: "var(--cta-color)" }), D(() => {
                N(ae, "href", a.checkoutUrl), L(pe, `${a.paywallCtaText ?? ""} `);
              }), A(H, ae);
            }, se = (H) => {
              var ae = Ki();
              ae.__click = function(...ct) {
                var Tt;
                (Tt = t.startSteadyFlow) == null || Tt.apply(this, ct);
              };
              var pe = p(ae), we = m(pe);
              Da(we, { color: "var(--cta-color)" }), D(() => L(pe, `${a.paywallCtaText ?? ""} `)), A(H, ae);
            };
            J(
              C,
              (H) => {
                a.checkoutActive && a.checkoutUrl ? H(K) : H(se, !1);
              },
              E
            );
          }
        };
        J(Ct, (C) => {
          a.paywallExpandable ? C(zt) : C(ot, !1);
        });
      }
      var De = m(me, 2);
      {
        var St = (C) => {
          var E = Xi(), K = p(E);
          ms(K, {
            oauth: zs,
            standalone: !1,
            get startPlanSteadyFlow() {
              return t.startPlanSteadyFlow;
            },
            get startGiftPlansSteadyFlow() {
              return t.startGiftPlansSteadyFlow;
            }
          }), sa(3, E, () => hs, () => ({ duration: 900, easing: Mt })), A(C, E);
        };
        J(De, (C) => {
          u(k) && C(St);
        });
      }
      var oe = m(le, 2), ce = p(oe);
      {
        var Te = (C) => {
          var E = Ji(), K = Ge(E), se = p(K), H = m(K, 2);
          H.__click = function(...pe) {
            var we;
            (we = t.signOut) == null || we.apply(this, pe);
          };
          var ae = p(H);
          D(
            (pe) => {
              L(se, `${pe ?? ""}  `), L(ae, a.localization.signOut);
            },
            [
              () => T(l.email)
            ]
          ), A(C, E);
        }, V = (C) => {
          var E = Qi(), K = Ge(E), se = p(K), H = m(K, 2);
          H.__click = function(...pe) {
            var we;
            (we = t.signIn) == null || we.apply(this, pe);
          };
          var ae = p(H);
          D(() => {
            L(se, `${a.localization.alreadyMember ?? ""}  `), L(ae, a.localization.signIn);
          }), A(C, E);
        };
        J(ce, (C) => {
          l ? C(Te) : C(V, !1);
        });
      }
      var _e = m(oe, 2);
      {
        var he = (C) => {
          _n(C, { widgetSettings: a, close: te });
        };
        J(_e, (C) => {
          a.paywallDismissible && C(he);
        });
      }
      rn(ue, (C) => j(g, C), () => u(g)), D(
        (C, E) => {
          P = Ae(I, "", P, {
            top: `${u(o)}px`,
            height: `${u(c)}px`,
            left: s ? "0" : `-${v}px`,
            width: s ? "100%" : `calc(100% + ${2 * v}px)`,
            "--cta-color": C
          }), de = Ae(ne, "", de, { height: u(h) }), ge = Ae(ue, "", ge, {
            width: s ? "100%" : "calc(100% - 10px)",
            position: E,
            top: u(d),
            bottom: u(f)
          }), L(Y, a.localization.paywallWarning), N(fe, "src", a.paywallImage), N(st, "src", a.paywallImage), L(Ie, a.paywallHeadline);
        },
        [
          () => ma(a.publicationBrandColor),
          () => Z() ? "absolute" : "sticky"
        ]
      ), A(w, I);
    };
    J(Q, (w) => {
      u(b) && w(x);
    });
  }
  A(e, O), mt();
}
xt(["click"]);
xt(["click"]);
const oa = (e) => {
  const t = e.getBoundingClientRect(), { body: a, documentElement: n } = document, s = window.scrollY || n.scrollTop || a.scrollTop, r = n.clientTop || a.clientTop || 0, i = t.top + s - r;
  return Math.round(i);
}, nl = (e) => {
  const { parentElement: t } = e;
  let { nextSibling: a } = e;
  for (; a; ) {
    const { textContent: n, nodeType: s, nextSibling: r } = a;
    if (t && (n != null && n.trim()) && s === Node.TEXT_NODE) {
      const i = document.createElement("span");
      i.textContent = n, i.setAttribute("data-wrapped", "true");
      const { nextSibling: l } = t.insertBefore(i, r);
      a.remove(), a = l;
    } else
      a = r;
  }
}, In = (e, t, a, n) => {
  if (e.hasAttribute(t)) {
    const s = e.getAttribute(t) ?? "";
    e.setAttribute(a, s);
  }
  e.setAttribute(t, n);
}, Pn = (e, t, a) => {
  if (e.removeAttribute(t), e.hasAttribute(a)) {
    const n = e.getAttribute(a) ?? "";
    e.setAttribute(t, n), e.removeAttribute(a);
  }
}, sl = (e, t) => {
  const a = oa(e), n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT);
  let s = n.firstChild(), r = [], i = !1;
  nl(e);
  const l = (c) => oa(c) - a > Ti ? (c.classList.add("steady_hidden_content__hidden"), !0) : (c.classList.add("steady_hidden_content__unselectable"), c.classList.add("steady_hidden_content__underlay"), In(c, "aria-hidden", ks, "true"), (zi.includes(c.tagName) || c.hasAttribute("tabindex")) && In(c, "tabindex", Cs, "-1"), !1);
  for (; s && s instanceof Element; ) {
    if (!(e.compareDocumentPosition(s) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      s = n.nextNode();
      continue;
    }
    if (Si.includes(s.tagName)) {
      s = n.nextSibling();
      continue;
    }
    if (i) {
      if (s.classList.add("steady_hidden_content__hidden"), r = [...r, s], t.lastElementChild === s)
        break;
      s = n.nextSibling() ?? n.nextNode();
      continue;
    }
    if (i = l(s), r = [...r, s], t.lastElementChild === s)
      break;
    s = n.nextSibling() ?? n.nextNode();
  }
  return r;
}, rl = (e, t) => {
  var a;
  for (const n of e) {
    if (n.classList.contains("steady_hidden_content__hidden")) {
      n.classList.remove("steady_hidden_content__hidden");
      continue;
    }
    if (n.hasAttribute("data-wrapped")) {
      const s = document.createTextNode(n.textContent ?? "");
      (a = n.parentElement) == null || a.replaceChild(s, n);
      continue;
    }
    n.classList.remove("steady_hidden_content__unselectable"), n.classList.remove("steady_hidden_content__underlay"), Pn(n, "tabindex", Cs), Pn(n, "aria-hidden", ks);
  }
}, gl = (e) => {
  class t extends HTMLElement {
    constructor() {
      super(...arguments);
      Wt(this, "_element", {});
    }
    connectedCallback() {
      const s = this.attachShadow({ mode: "open" });
      this._element = tn(al, {
        target: s,
        props: e
      });
    }
    disconnectedCallback() {
      an(this._element);
    }
  }
  customElements.define("steady-paywall", t);
}, il = "steady-smart-layer-data-visits", ll = "steady-smart-layer-data-total-time", ol = "steady-smart-layer-data-referrer", cl = (e) => {
  const t = _l(), { size: a } = new Set(t), n = dl(), s = ul();
  return {
    visitsInTheLastPeriod: a,
    totalTimeOnSiteInSeconds: n,
    referrerDomain: s,
    oauth: e
  };
}, _l = () => {
  const e = localStorage.getItem(il) ?? "null", t = JSON.parse(e);
  return Array.isArray(t) && t.every((n) => typeof n == "number") ? t : [];
}, dl = () => {
  const e = localStorage.getItem(ll) ?? "";
  return parseInt(e) || 0;
}, ul = () => localStorage.getItem(ol) ?? "", vl = (e) => {
  const { visitsInTheLastPeriod: t, totalTimeOnSiteInSeconds: a, oauth: n } = e, s = sessionStorage.getItem(Wi), r = 3, i = 360, l = 2, c = 1;
  return n.hasAccess ? "member" : n.isSubscriber || s === "true" ? "subscriber" : "email" in n && n.email ? "user" : t >= r && a >= i ? "loyal" : t >= l && a >= c ? "returning" : "first timer";
}, Ts = (e, t) => {
  const n = new IntersectionObserver(
    (s) => {
      s.forEach((r) => {
        r.isIntersecting && (Vt(e, t, "shown"), n.unobserve(r.target));
      });
    },
    { threshold: 0.5 }
  );
  return n;
}, Vt = (e, t, a) => {
  const { oauthClientId: n, layerHitUrl: s } = window.SteadyWidgetSettings, r = cl(e), i = vl(r);
  fetch(s, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      visitorType: i,
      event: a,
      oauthClientId: n,
      layer: t
    })
  });
};
var fl = /* @__PURE__ */ U('<img aria-hidden="true" alt="" class="steady_engagement_wall__image svelte-151wjma" data-testid="steady_engagement_wall_image">'), hl = /* @__PURE__ */ U('<section id="steady_engagement_wall" data-testid="steady_engagement_wall"><!> <div class="steady_engagement_wall__content svelte-151wjma"><h2 class="steady_engagement_wall__content__headline svelte-151wjma"> </h2> <p class="steady_engagement_wall__content__description svelte-151wjma"><!></p> <a target="_blank" class="steady_engagement_wall__content__cta svelte-151wjma"> <!></a></div> <!></section>');
const pl = {
  hash: "svelte-151wjma",
  code: `
#steady_engagement_wall.svelte-151wjma {all:initial;box-sizing:border-box;}
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma):where(:not(html, iframe, canvas, svg, video, audio):not(svg *, symbol *)) {all:unset;display:revert;}
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma),
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma)::before,
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma)::after {box-sizing:border-box;}
#steady_engagement_wall.svelte-151wjma a:where(.svelte-151wjma) {cursor:pointer;}
#steady_engagement_wall.svelte-151wjma img:where(.svelte-151wjma) {max-inline-size:100%;max-block-size:100%;margin:0;padding:0;overflow:clip;overflow-clip-margin:content-box;border:none;box-shadow:none;}
#steady_engagement_wall.svelte-151wjma :where(pre) {all:revert;box-sizing:border-box;}
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma)::placeholder {color:unset;}
#steady_engagement_wall.svelte-151wjma :where([contenteditable]:not([contenteditable="false"])) {-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto;}
#steady_engagement_wall.svelte-151wjma :where([draggable="true"]) {-webkit-user-drag:element;}
#steady_engagement_wall.svelte-151wjma :where(dialog:modal) {all:revert;box-sizing:border-box;}
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma)::-webkit-details-marker {display:none;}
#steady_engagement_wall.svelte-151wjma :where(.svelte-151wjma):focus-visible {outline:revert;}#steady_engagement_wall.svelte-151wjma {position:fixed;bottom:0;left:0;z-index:2000;display:flex;flex-direction:column;align-items:center;width:100%;border-top:1px solid #e3e3e3;color:#271f36;font-size:12px;font-family:"CircularStd", Arial, sans-serif;line-height:16px;background:white;}
@media (min-width: 768px) {#steady_engagement_wall.svelte-151wjma {font-size:15px;line-height:20px;}
}#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content:where(.svelte-151wjma) {display:grid;align-content:center;}#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content__headline:where(.svelte-151wjma) {font-weight:normal;text-align:center;}#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content__description:where(.svelte-151wjma) {margin:0;text-align:center;font-size:12px;line-height:16px;word-break:break-word;}
@media (min-width: 768px) {#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content__description:where(.svelte-151wjma) {font-size:15px;line-height:20px;}
}#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content__cta:where(.svelte-151wjma) {justify-self:center;display:flex;align-items:center;font-weight:500;font-size:13px;letter-spacing:0.5px;white-space:normal;text-transform:uppercase;overflow-wrap:break-word;}
@media (min-width: 768px) {#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content__cta:where(.svelte-151wjma) {white-space:nowrap;overflow-wrap:normal;}
}#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__content__cta:where(.svelte-151wjma):where(:where(.svelte-151wjma):hover, :where(.svelte-151wjma):focus) {opacity:80%;}#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__image:where(.svelte-151wjma) {width:80px;height:80px;margin-top:60px;border-radius:10px;}
@media (min-width: 768px) {#steady_engagement_wall.svelte-151wjma .steady_engagement_wall__image:where(.svelte-151wjma) {width:210px;height:210px;margin-top:0;margin-right:110px;}
}#steady_engagement_wall.steady_engagement_wall--small.svelte-151wjma {height:120px;}
@media (min-width: 768px) {#steady_engagement_wall.steady_engagement_wall--small.svelte-151wjma {height:100px;}
}#steady_engagement_wall.steady_engagement_wall--small.svelte-151wjma .steady_engagement_wall__content:where(.svelte-151wjma) {height:100%;}#steady_engagement_wall.steady_engagement_wall--small.svelte-151wjma .steady_engagement_wall__content__headline:where(.svelte-151wjma) {font-weight:500;font-size:20px;line-height:24px;letter-spacing:-1px;word-break:break-word;margin:0 0 2px;}#steady_engagement_wall.steady_engagement_wall--small.svelte-151wjma .steady_engagement_wall__content__cta:where(.svelte-151wjma) {margin-top:8px;}#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma {justify-content:center;height:365px;}
@media (min-width: 768px) {#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma {flex-direction:row;height:400px;}
}#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content:where(.svelte-151wjma) {align-content:flex-start;max-width:400px;padding:30px;}
@media (min-width: 768px) {#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content:where(.svelte-151wjma) {align-content:normal;padding:0;}
}#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content__headline:where(.svelte-151wjma) {margin:0 0 10px;font-weight:500;font-size:20px;line-height:24px;letter-spacing:-1px;word-break:break-word;}
@media (min-width: 768px) {#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content__headline:where(.svelte-151wjma) {margin:0 0 20px;text-align:left;text-wrap:balance;font-size:42px;line-height:44px;}
}
@media (min-width: 768px) {#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content__description:where(.svelte-151wjma) {text-align:left;}
}#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content__cta:where(.svelte-151wjma) {margin-top:25px;}
@media (min-width: 768px) {#steady_engagement_wall.steady_engagement_wall--large.svelte-151wjma .steady_engagement_wall__content__cta:where(.svelte-151wjma) {justify-self:flex-start;}
}`
};
function wl(e, t) {
  gt(t, !0), nt(e, pl);
  const a = window.SteadyWidgetSettings;
  let n = X(!1);
  const s = "steady-engagement-wall-closed", r = () => {
    j(n, !1), sessionStorage.setItem(s, "true");
  }, i = () => {
    const d = sessionStorage.getItem(s);
    (d === null || d === "") && j(n, !0);
  };
  Ft(() => {
    i(), u(n) && Vt(t.oauth, "announcement", "shown");
  });
  var l = ga(), c = Ge(l);
  {
    var o = (d) => {
      var f = hl();
      let _;
      var v = p(f);
      {
        var h = (G) => {
          var R = fl();
          N(R, "width", 80), N(R, "height", 80), D(() => N(R, "src", a.engagementWallImage)), A(G, R);
        };
        J(v, (G) => {
          a.engagementWallType === "large" && G(h);
        });
      }
      var b = m(v, 2), k = p(b), g = p(k), z = m(k, 2), S = p(z);
      {
        var T = (G) => {
          var R = mn();
          D(() => L(R, a.engagementWallLongDescription)), A(G, R);
        }, y = (G, R) => {
          {
            var Z = (re) => {
              var ie = mn();
              D(() => L(ie, a.engagementWallShortDescription)), A(re, ie);
            };
            J(
              G,
              (re) => {
                a.engagementWallType === "small" && re(Z);
              },
              R
            );
          }
        };
        J(S, (G) => {
          a.engagementWallType === "large" ? G(T) : G(y, !1);
        });
      }
      var M = m(z, 2);
      Ae(M, "", {}, { color: "var(--cta-color)" });
      var $ = p(M), q = m($);
      Da(q, { color: "var(--cta-color)" });
      var te = m(b, 2);
      _n(te, { widgetSettings: a, close: r }), D(
        (G) => {
          Be(f, 1, `steady_engagement_wall--${a.engagementWallType ?? ""}`, "svelte-151wjma"), _ = Ae(f, "", _, { "--cta-color": G }), L(g, a.engagementWallHeadline), N(M, "href", a.engagementWallCtaUrl), L($, `${a.engagementWallCtaText ?? ""} `);
        },
        [
          () => ma(a.publicationBrandColor)
        ]
      ), sa(5, f, () => fs, () => ({ duration: 500 })), A(d, f);
    };
    J(c, (d) => {
      u(n) && d(o);
    });
  }
  A(e, l), mt();
}
const ml = (e) => {
  class t extends HTMLElement {
    constructor() {
      super(...arguments);
      Wt(this, "_element", {});
    }
    connectedCallback() {
      const s = this.attachShadow({ mode: "open" });
      this._element = tn(wl, {
        target: s,
        intro: !0,
        props: e
      });
    }
    disconnectedCallback() {
      an(this._element);
    }
  }
  customElements.define("steady-engagement-wall", t);
};
export {
  bl as registerAdblock,
  ml as registerEngagementWall,
  gl as registerPaywall
};
